import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DoCheck,
    OnInit,
    ViewChild,
    ViewContainerRef,
} from "@angular/core";
import {
    EmitEvent,
    EventBusService,
} from "../../../core/services/event-bus.service";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { SharedDataService } from "../../../shared/sharedData.service";
import * as _ from "lodash";
import moment from "moment";
import { StatusColorService } from "../../timesheet-details/service/status-color.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NbcBudgetCodeComponent } from "../../components/nbc-budget-code/nbc-budget-code.component";
import { Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { BudgetCodeService } from "../../../shared/services/budget-code.service";
import { CdkDragDrop } from "@angular/cdk/drag-drop";
import { SubSink } from "subsink";
import { OnDestroy } from "@angular/core";

@Component({
    selector: "timesheet-grid-row",
    templateUrl: "./grid-row.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class _TimesheetGridRowComponent implements OnInit, OnDestroy, DoCheck {
    constructor(
        private _eventBusService: EventBusService,
        private _sharedDataService: SharedDataService,
        private budgetService: BudgetCodeService,
        private colorsService: StatusColorService,
        private viewContainerRef: ViewContainerRef,
        public _modalService: BsModalService,
        @Inject(DOCUMENT) private _document: Document,
        public _cd: ChangeDetectorRef,
        public modalBudgetCodeRef: BsModalRef,
        private log: NbcLoggerService
    ) {
        this.colors = this.colorsService.getColors();
        this._cd.detach();
    }

    @ViewChild("grid_row_template", { static: true }) grid_row_template;
    subs: SubSink = new SubSink();
    colors: any;
    TIMECARDRATE_DEFAULT = 15.0;
    DEFAULT_RATE_CODE = "00";
    AftraUnionCodes = ["UNE", "RTS"];
    rateLimit: any = 6000;

    timesheetDate: any;
    timesheetType: any;
    timesheetListItems: any;
    buAccess: any;
    user: any = window.preload.user;

    daytypes: any = [];
    workStates: any = [];
    employeeTypes: any = [];
    networks: any = [];
    sports: any = [];
    companyCodes: any = [];
    unionCodes: any = [];
    payrollProviders: any = [];
    contractCodes: any = [];
    jobCodes: any = [];
    jobCodeDetails: any = [];
    defaultConfigs: any = [];
    payrollDefaultsList: any = [];
    chargeCodeTypes: any = [];
    departments: any = [];

    allJobCodes: any = [];
    allContractCodes: any = [];
    modifiedListItems: any = [];

    IsOperationDeptExpanded = false;
    IsTalentDeptExpanded = false;
    IsFinanceDeptExpanded = false;
    IsPayrollDeptExpanded = false;

    hasTalentDepartment = false;
    hasFinanceDepartment = false;
    hasPayrollDepartment = false;

    field_firstName = "firstName";
    field_activityDate = "activityDate";
    field_eventShowName = "eventShowName";
    field_dayType = "dayType";
    field_network = "network";
    field_employeeType = "employeeType";
    field_stateContactWorked = "stateContactWorked";
    field_customRate = "customRate";
    field_wbse = "wbse";
    field_costCenter = "costCenter";
    field_glAccount = "glAccount";
    field_payrollProvider = "payrollProvider";
    field_contractCode = "contractCode";
    field_jobCode = "jobCode";
    field_payTransactions = "payTransactions";
    field_hoursWorked = "hoursWorked";
    field_wageType = "wageType";
    field_wageschedule = "wageschedule";
    field_ratecode = "rateCode";
    field_unioncode = "unionCode";
    field_sport = "sport";
    field_payrollCostCenter = "payrollCostCenter";
    dept_Operation = "SUBMITTER";
    dept_Talent = "APPROVER";
    dept_Finance = "FINANCE";
    dept_Payroll = "PAYROLL";

    //holding DnD vallues from flyout
    list2: any[] = [];

    /*
     * Every department has different mandatory field needs. So, we have constructed an object with property names
     */

    mandatoryFields = [
        {
            department: this.dept_Operation,
            fields: [
                this.field_firstName,
                this.field_activityDate,
                this.field_eventShowName,
                this.field_customRate,
                this.field_network,
                this.field_employeeType,
                this.field_dayType,
            ],
        },
        {
            department: this.dept_Talent,
            fields: [
                this.field_activityDate,
                this.field_eventShowName,
                this.field_customRate,
            ],
        },
        {
            department: this.dept_Finance,
            //SCOR-15775
            //"fields": [field_activityDate, this. field_eventShowName, this. field_network, this. field_employeeType, this. field_customRate, this. field_wbse, this. field_glAccount, this. field_wageType]
            fields: [
                this.field_activityDate,
                this.field_eventShowName,
                this.field_network,
                this.field_employeeType,
                this.field_customRate,
                this.field_wbse,
                this.field_glAccount,
                this.field_dayType,
            ],
        },
        {
            department: this.dept_Payroll,
            fields: [
                this.field_activityDate,
                this.field_eventShowName,
                this.field_network,
                this.field_employeeType,
                this.field_customRate,
                this.field_wbse,
                this.field_glAccount,
                this.field_payrollProvider,
                this.field_contractCode,
                this.field_jobCode,
                this.field_payTransactions,
                this.field_wageType,
                this.field_wageschedule,
                this.field_dayType,
            ],
        },
    ];

    mandatoryConfig: any = {};

    businessValidation = {
        isFieldEnabled: false,
        isContactAvailable: false,
        isSelfQueueRecord: false,
        isWorkStateValidation: false,
        isFutureActivity: false,
        isAftraRecord: false,
        //below name is to be changed when we get to the validation
        isSpecialCondition: false,
        isWageTypeRequired: false,
        //"isWageScheduleRequired":false, //this check is not required in Talent; commenting per defect SCOR-22282
        isFinanceFieldEnabled: false,
        isSSOValid: true,
        isPernerValid: true,
        isRateValid: false,
        isWBSEValid: false,
        isGLAccountRequired: false,
        canSelect: false,
    };
    SPBStatusValidation = {
        isSubmitted: false,
        isUnAuthorized: false,
        isRejected: false,
    };

    uiDeptSettings: any;

    getListItemById(listId) {
        return _.find(this.modifiedListItems, { id: listId });
    }

    getListItemIndex(listId) {
        return _.findIndex(this.modifiedListItems, { id: listId });
    }

    getChildListItem(parentListId) {
        return _.find(this.modifiedListItems, { parentTimecard: parentListId });
    }

    getChildListItemIndex(parentListId) {
        return _.findIndex(this.modifiedListItems, {
            parentTimecard: parentListId,
        });
    }

    getJobCodeIndex(unionCode) {
        return _.findIndex(this.allJobCodes, { code: unionCode });
    }

    onMasterDataReceived(data) {
        this.workStates = data.workStates;
        this.employeeTypes = data.employeeTypes;
        this.sports = data.sports;
        this.networks = data.networks;
        this.unionCodes = data.unionCodes;
        this.payrollProviders = data.payrollProviders;
        this.chargeCodeTypes = data.chargecodeTypes;
        this.daytypes = data.daytypes;

        this.defaultConfigs = data.defaultConfigs;
        this.payrollDefaultsList = data.payrollDefaults;
        this.companyCodes = data.companyCodes;

        this.jobCodes = data.jobCodes;
        this.contractCodes = data.contractCodes;
        this.departments = data.departments;
    }

    onDemandChangeDetection() {
        setTimeout(() => this._cd.detectChanges(), 100);
    }

    getBUAccessIdList(departments) {
        const deptWithAccess = [];
        if (!_.isEmpty(departments)) {
            let currentSeqNo = 0;
            //var currentSeqNo = _.find(departments, { "id": BuAccess.departmentId }).displaySequence;
            _.forEach(departments, (dept) => {
                if (dept.department.id === this.buAccess.departmentId) {
                    currentSeqNo = dept.displaySequence;
                }
            });
            _.forEach(departments, (dept) => {
                if (dept.displaySequence <= currentSeqNo) {
                    deptWithAccess.push(dept.id);
                }
            });
        }
        return deptWithAccess;
    }

    getPreviousDeptInQueue(departments) {
        const deptPreQueue = [];
        if (!_.isEmpty(departments)) {
            _.forEach(departments, (dept) => {
                if (dept.department.id < this.buAccess.departmentId) {
                    deptPreQueue.push(dept);
                }
            });
        }
        return deptPreQueue;
    }
    getDefaultsForEmpType(emptype) {
        return _.find(this.defaultConfigs, (o) => o.employeeType === emptype);
    }

    checkIfRateRequired(item) {
        if (item.employeeType && !_.isEmpty(item.employeeType.id)) {
            const value = _.find(
                this.defaultConfigs,
                (o) => o.employeeType === item.employeeType.id
            );
            if (this.buAccess.department === this.dept_Operation) {
                return value
                    ? value.isRateRequired && !this.hasTalentDepartment
                    : false;
            } else {
                return value ? value.isRateRequired : false;
            }
        }
        return false;
    }
    checkIfWBSERequired(item) {
        if (item.employeeType && !_.isEmpty(item.employeeType.id)) {
            const value = _.find(
                this.defaultConfigs,
                (o) => o.employeeType === item.employeeType.id
            );
            return value
                ? value.iswbseRequired &&
                      (this.buAccess.department === this.dept_Finance ||
                          this.buAccess.department === this.dept_Payroll)
                : false;
        }
        return false;
    }

    checkIfGlAccountRequired(item) {
        if (item.employeeType && !_.isEmpty(item.employeeType.id)) {
            const value = _.find(
                this.defaultConfigs,
                (o) => o.employeeType === item.employeeType.id
            );
            return value
                ? value.isGlAccountRequired &&
                      (this.buAccess.department === this.dept_Finance ||
                          this.buAccess.department === this.dept_Payroll)
                : false;
        }
        return false;
    }

    fieldRequired(item) {
        item.businessValidation.isRateValid = this.checkIfRateRequired(item);
        item.businessValidation.isWBSEValid = this.checkIfWBSERequired(item);
        item.businessValidation.isGLAccountRequired =
            this.checkIfGlAccountRequired(item);

        ////TODO: NOT NEEDED:CONFIRM AND DELETE
        //var rateEle = getRateEle(item.id);
        //var wbseEle = getWBSEEle(item.id);
        //var ccEle = getCostCenterEle(item.id);
        //var glAccountEle = getGlAccountEle(item.id);

        //Setting Condition For Special Taxation
        if (
            item?.employeeType?.id === "DHST" &&
            this.buAccess.department === this.dept_Finance
        ) {
            item.businessValidation.isRateValid = true;
            item.businessValidation.isWBSEValid = true;
            item.businessValidation.isGLAccountRequired = true;
        }
        //Changed condition according to SCOR-17033
        if (this.buAccess.department === this.dept_Operation) {
            if (
                !this.hasTalentDepartment &&
                item.businessValidation.isRateValid
            ) {
                //TODO: move to the UI with dynamic class
                //rateEle.addClass("required-outline");
            } else {
                //rateEle.removeClass("required-outline");
                this.highlightField(false, this.field_customRate, item.id);
            }
        } else {
            if (item.businessValidation.isRateValid) {
                // rateEle.addClass("required-outline");
            } else {
                // rateEle.removeClass("required-outline");
                this.highlightField(false, this.field_customRate, item.id);
            }
            if (item.businessValidation.isWBSEValid) {
                //wbseEle.addClass("required-outline");
                //ccEle.addClass("required-outline");
            } else {
                //wbseEle.removeClass("required-outline");
                //ccEle.removeClass("required-outline");
                if ((_.isEmpty(item.wbse) ||
                    _.isEmpty(_.trim(item.wbse)) ||
                    _.isEmpty(_.trim(item.wbseDescription)))
                )
                {
                    const isWbseRequired = this.checkIfWBSERequired(item);
                    this.highlightField(
                        (
                            _.isEmpty(_.trim(item.wbse)) && 
                            !isWbseRequired
                        ) ? false : true,
                        item.isWbse ? this.field_wbse : this.field_costCenter,
                        item.id,
                        isWbseRequired ? true : false
                    );
                }
            }
            if (item.businessValidation.isGLAccountRequired) {
                //glAccountEle.addClass("required-outline");
            } else {
                //glAccountEle.removeClass("required-outline");
                this.highlightField(false, this.field_glAccount, item.id);
            }
        }
    }
    transformJobCode(item) {
        // Job Codes Save and Return as JOBCODE+RATECODE ex: NTA00

        if (!_.isEmpty(item.jobCode)) {
            if (item.jobCode) {
                item.selectedJobCode = item.jobCode.substr(0, 3);
            } else {
                item.selectedJobCode = item.jobCode;
            }
        }
        return item;
    }

    /**
     * Set Default Job Code Details
     * @memberof score.directives.talentPayrollTimesheetGrid
     * @function defaultJobCodeDetails
     * @param {payrollTimesheet} item
     * @param {String} jobCode
     * @returns {payrollTimesheet}
     */
    defaultJobCodeDetails(item, jobCode) {
        if (jobCode && jobCode.details) {
            item.jobCodeDetails = jobCode.details;
            item.jobCodeDetail = _.find(this.allJobCodes, {
                code: jobCode.details[0].employeeType,
            });
        } else {
            item.jobCodeDetails = [
                {
                    id: 0,
                    code: null,
                    title: null,
                    employeeType: null,
                    rateCode: this.DEFAULT_RATE_CODE,
                },
            ];
            item.jobCodeDetail = item.jobCodeDetails[0];
        }

        return item;
    }

    /**
     * Get Duration
     * @memberof score.directives.talentPayrollTimesheetGrid
     * @param {DateTime} startDate
     * @param {DateTime} endDate
     * @returns {}
     * @private
     */
    getDuration(startDate, endDate) {
        if (moment(startDate).isAfter(moment(endDate))) {
            return "";
        }
        const dateDiff = moment(endDate).diff(moment(startDate), "minutes");
        const hours = Math.floor(dateDiff / 60);
        const minutes = dateDiff % 60;
        let duration = "";
        if (hours === 0) {
            duration = minutes + " min";
        } else if (hours > 0 && minutes > 0) {
            duration = hours + "h " + minutes + " min";
        } else if (hours > 0 && minutes === 0) {
            duration = hours + " h";
        }
        return duration;
    }

    /**
     * Surppress Initial System Message
     * @memberof score.directives.talentPayrollTimesheetGrid
     * @function suppressInitMessage
     * @param {String} message
     * @returns {String}
     */
    suppressInitMessage(message) {
        const initSysMessage = "EVENTID is not Available in TK",
            replaceRegex =
                /EVENTID is not Available in TK|,EVENTID is not Available in TK|ERROR\|\|EVENTID is not Available in TK/i,
            suppressInitSystemMessage = message
                .toLowerCase()
                .indexOf(initSysMessage.toLowerCase());
        if (suppressInitSystemMessage > -1) {
            message = message.replace(replaceRegex, "").trim();
        }

        return message;
    }

    filterTerms(error) {
        return error.toLowerCase() !== "error";
    }

    /**
     * Set System Error Messages
     * @memberof score.directives.talentPayrollTimesheetGrid
     * @function setSystemErrorMessages
     * @param {payrollTimesheet} item
     * @returns {payrollTimesheet}
     */
    setSystemErrorMessages(item) {
        let errors;
        if (item.systemMessage) {
            item.systemMessage = this.suppressInitMessage(item.systemMessage);

            errors = item.systemMessage.split("||");

            errors = _.without(errors, "");

            if (errors.length) {
                item.systemErrors = errors.filter(this.filterTerms);
            }
        }

        return item;
    }

    /**
     * Creates timesheet display status
     * @memberof score.directives.talentPayrollTimesheetGrid
     * @function transformTimesheetDisplayStatus
     * @param {payrollTimesheet} item
     * @returns {payrollTimesheet}
     */
    transformTimesheetDisplayStatus(item) {
        if (
            _.lowerCase(item.timesheetStatus) === "late" ||
            _.lowerCase(item.timesheetStatus) === "in progress"
        ) {
            item.displayTimesheetStatus = "Not Submitted";
        } else {
            item.displayTimesheetStatus = item.timesheetStatus;
        }

        return item;
    }

    //Every timecard will have different status w.r.t user loggeed in.
    getInQueueStatus(item) {
        return _.find(
            item.timecardStatus,
            (o) => o.tpmDepartment.id === this.buAccess.departmentId
        );
    }

    canSubmitDept(item, token) {
        return (
            _.includes(Object.keys(this.user.allFeatures), token) &&
            ((item.businessValidation.isSelfDeptCreatedRecord &&
                item.queueStatus === "PREQUEUE") ||
                (item.queueStatus === "INQUEUE" && !item.parentTimecard))
        );
    }

    canTcSaveDept(item, token) {
        return (
            _.includes(Object.keys(this.user.allFeatures), token) &&
            ((item.businessValidation.isSelfDeptCreatedRecord &&
                item.queueStatus === "PREQUEUE") ||
                (item.queueStatus === "INQUEUE" && !item.parentTimecard))
        );
    }

    canRejectDept(item, token) {
        return (
            _.includes(Object.keys(this.user.allFeatures), token) &&
            item.queueStatus === "INQUEUE" &&
            !item.parentTimecard
        );
    }

    checkPayrollRecordEditAccess(item, parentItem) {
        if (item.employeeType && !_.isEmpty(item.employeeType.id)) {
            const value = _.find(
                this.defaultConfigs,
                (o) => o.employeeType === item.employeeType.id
            );

            // sometimes, we may have possibility to have Employee types with TK as payroll provider in default config but user may choose different PP.
            let checkPayrollProviderOveride = false;
            if (!parentItem) {
                checkPayrollProviderOveride =
                    (item.payrollProvider &&
                        item.payrollProvider.id === "OTHER" &&
                        item.isPayrollSubmitted === "Y") ||
                    (item.payrollProvider &&
                        item.payrollProvider.id === "SPB" &&
                        (item.paymentStatus === "Authorized" ||
                            item.paymentStatus === "Paid"));
            } else {
                checkPayrollProviderOveride =
                    (parentItem.payrollProvider &&
                        parentItem.payrollProvider.id === "OTHER" &&
                        parentItem.isPayrollSubmitted === "Y") ||
                    (parentItem.payrollProvider &&
                        parentItem.payrollProvider.id === "SPB" &&
                        (parentItem.paymentStatus === "Authorized" ||
                            parentItem.paymentStatus === "Paid"));
            }
            if (checkPayrollProviderOveride) {
                return false;
            } else {
                return value ? !value.isReadOnlyTimecard : !false;
            }
        }
        return false;
    }

    /*
     * This is validation required by Business validation to enable work state.
     * Method will get called during inital load as well as employee type change.
     */
    checkIfWorkStateEnabled(item) {
        if (item.employeeType && !_.isEmpty(item.employeeType.id)) {
            const value = _.find(
                this.defaultConfigs,
                (o) => o.employeeType === item.employeeType.id
            );
            return value ? value.isWorkStateRequired : false;
        }
        return false;
    }

    transformTimesheetWorkFlowStatus(item, aftraItem) {
        if (
            (item.isPayrollSubmitted &&
                _.indexOf(
                    ["Paid", "COMPLETED", "Processed", "Approved"],
                    item.paymentStatus
                ) >= 0) ||
            item.paymentStatus === "COMPLETED"
        ) {
            if (aftraItem) {
                aftraItem.timesheetWorkflowDeptColor =
                    this.colors.timesheetWorkflowStatus.get("approved");
                aftraItem.processingDeptDisplayName = "Approved";
            }
            item.timesheetWorkflowDeptColor =
                this.colors.timesheetWorkflowStatus.get("approved");
            item.processingDeptDisplayName = "Approved";
        } else if (_.isUndefined(item.timesheetWorkflowDeptColor)) {
            item.timesheetWorkflowDeptColor =
                this.colors.timesheetWorkflowStatus.get(
                    _.lowerCase(item.currentProcessingDepartment.description)
                );
            item.processingDeptDisplayName = _.startCase(
                _.lowerCase(item.currentProcessingDepartment.description)
            );
        }
    }

    checkContactValidation(item) {
        if (!_.isEmpty(item.contact)) {
            if (this.checkIfSSORequired(item)) {
                item.businessValidation.isSSOValid = item.contact.sso;
            } else {
                item.businessValidation.isSSOValid = true;
            }
            if (this.checkIfPernerRequired(item)) {
                item.businessValidation.isPernerValid = item.contact.perNer;
            } else {
                item.businessValidation.isPernerValid = true;
            }
        }
    }
    checkIfSSORequired(item) {
        if (
            item.businessValidation.canSubmitFinance &&
            item.employeeType &&
            !_.isEmpty(item.employeeType.id)
        ) {
            const value = _.find(
                this.defaultConfigs,
                (o) => o.employeeType === item.employeeType.id
            );
            return value ? value.isssoRequired : false;
        }
        return false;
    }

    checkIfPernerRequired(item) {
        if (
            item.businessValidation.canSubmitFinance &&
            item.employeeType &&
            !_.isEmpty(item.employeeType.id)
        ) {
            const value = _.find(
                this.defaultConfigs,
                (o) => o.employeeType === item.employeeType.id
            );
            return value ? value.isPerNerRequired : false;
        }
        return false;
    }

    //getBUAccessKeyList(departments) {
    //  var deptKeysWithAccess = [];
    //  if (!_.isEmpty(departments)) {
    //    var currentSeqNo = 0;
    //    departments = _.orderBy(departments, ["displaySequence"], ["asc"]);
    //    //var currentSeqNo = _.find(departments, { "id": BuAccess.departmentId }).displaySequence;
    //    _.forEach(departments, (dept)=> {
    //      if (dept.department.id === this.buAccess.departmentId) {
    //        currentSeqNo = dept.displaySequence;
    //      }
    //    });
    //    _.forEach(departments, (dept) =>{
    //      if (dept.displaySequence <= currentSeqNo) {
    //        deptKeysWithAccess.push(dept.department.externalKey);
    //      }
    //    });
    //  }
    //  //  console.log(deptKeysWithAccess);
    //  return deptKeysWithAccess;
    //}

    // we need to disable timecard selection for the rows which has been approved/authorized or above. This will be enabled
    //once the userr makes any change in the
    isPayrollTimesheetSelectDisabled(item) {
        if (item.currentProcessingDepartment.description === "PAYROLL") {
            if (
                _.lowerCase(item.paymentStatus) === "approved" ||
                _.lowerCase(item.paymentStatus) === "processed" ||
                _.lowerCase(item.paymentStatus) === "authorized" ||
                _.lowerCase(item.paymentStatus) === "paid"
            ) {
                return true;
            }
        }
        return false;
    }

    /*
     * create an object with mandatory properties
     */
    getMandatoryFields() {
        const fields = _.find(this.mandatoryFields, {
            department: this.buAccess.department,
        }).fields;

        for (let i = 0; i < fields.length; i++) {
            if (!_.has(this.mandatoryConfig, [fields[i]])) {
                if (
                    fields[i] === this.field_customRate &&
                    this.buAccess.department === this.dept_Operation &&
                    this.hasTalentDepartment
                ) {
                    // No need to add the mandatoryConfig for Rate and Network
                } else {
                    this.mandatoryConfig[fields[i]] = true;
                }
            }
        }
    }

    ///*  //initUiDeptSections(deptKeysWithAccess)*/ {
    //  var currentUserDeptKey = null;
    //  _.forEach(this.departments, (dept) => {
    //    if (dept.department.id === this.buAccess.departmentId) {
    //      currentUserDeptKey = dept.department.externalKey;
    //    }
    //  });
    //  //TODO: To be taken care in UI
    //  //if (!_.isEmpty(deptKeysWithAccess)) {

    //  //  /* SCOR-15290 */
    //  //  if (IsOperationDeptExpanded !== true) {
    //  //    opsDeptCollapsed();
    //  //  }
    //  //  else {
    //  //    $(".ops-collapsed-bar").hide();
    //  //  }

    //  //  if (IsTalentDeptExpanded !== true) {
    //  //    talentDeptCollpased();
    //  //  }
    //  //  else {
    //  //    $(".talnt-collapsed-bar").hide();
    //  //  }

    //  //  if (IsFinanceDeptExpanded !== true) {
    //  //    financeDeptCollpased();
    //  //  }
    //  //  else {
    //  //    $(".fin-collapsed-bar").hide();
    //  //  }

    //  //  if (IsPayrollDeptExpanded !== true) {
    //  //    payrollDeptCollapsed();
    //  //  }
    //  //  else {
    //  //    $(".payDept-collapsed-bar").show();
    //  //  }

    //  //link the allowed event handlers
    //  _.forEach(deptKeysWithAccess, (deptKey) => {
    //    switch (deptKey) {
    //      case this.dept_Operation:
    //        //TODO: do this in UI
    //        //$grid.on("click", opsDeptCollpseSelector, opsDeptCollapsed);
    //        //$grid.on("click", opsDeptExpandSelector, opsDeptExpanded);
    //        if (deptKey === currentUserDeptKey) {
    //          this.toggleUiDeptVisibility("isOperationDeptExpanded");
    //        }
    //        break;
    //      case this.dept_Talent:
    //        //$grid.on("click", talentDeptCollpseSelector, talentDeptCollpased);
    //        //$grid.on("click", talentDeptExpandSelector, talentDeptExpanded);
    //        if (deptKey === currentUserDeptKey) {
    //          this.toggleUiDeptVisibility("isOperationDeptExpanded");
    //          this.toggleUiDeptVisibility("isTalentDeptExpanded");
    //        }
    //        break;
    //      case this.dept_Finance:
    //        //$grid.on("click", financeDeptCollpseSelector, financeDeptCollpased);
    //        //$grid.on("click", financeDeptExpandSelector, financeDeptExpanded);
    //        if (deptKey === currentUserDeptKey) {
    //          this.toggleUiDeptVisibility("isOperationDeptExpanded");
    //          this.toggleUiDeptVisibility("isTalentDeptExpanded");
    //          this.toggleUiDeptVisibility("isFinanceDeptExpanded");
    //        }
    //        break;
    //      case this.dept_Payroll:
    //        //$grid.on("click", payrollDeptCollpseSelector, payrollDeptCollapsed);
    //        //$grid.on("click", payrollDeptExpandSelector, payrollDeptExpanded);
    //        if (deptKey === currentUserDeptKey) {
    //          this.toggleUiDeptVisibility("isPayrollDeptExpanded");
    //        }
    //        break;
    //    }
    //  });

    //}

    selectWBSEModal(listId) {
        const itemIndex = this.getListItemIndex(listId);

        const initialState: any = {
            self: this,
        };
        const modalOptions = {
            animated: true,
            keyboard: false,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState: initialState,
        };

        this.modalBudgetCodeRef = this._modalService.show(
            NbcBudgetCodeComponent,
            modalOptions
        );
        this.modalBudgetCodeRef.content.onSync.subscribe((wbse) => {
            if (wbse && wbse.code) {
                if (itemIndex > -1) {
                    this.modifiedListItems[itemIndex].wbse = wbse.code;
                    this.modifiedListItems[itemIndex].wbseDescription =
                        wbse.description;
                    this.setChanged(this.modifiedListItems[itemIndex]);
                    this.setCompanyCode(wbse.coCode, itemIndex);
                }
            }
        });
    }

    onWbseCopyPasteOnly(index, val) {
        //listItemIndex = getListItemIndex(id),
        const listItem = this.modifiedListItems[index];
        const aftraChild = this.getChildListItem(listItem.id);
        val = listItem.wbse;
        if (!_.isEmpty(val)) {
            const wbseValue = val.split(".");
            const tail = wbseValue.slice(2).join(".");
            const result = wbseValue.slice(0, 2);
            result.push(tail);

            const budgetQuery: any = {
                pageSize: 10,
                currentPage: 1,
                code: !_.isEmpty(result[2]) ? result[2] : "",
                description: "",
                coCode: !_.isEmpty(result[0]) ? result[0] : "",
            };

            this.subs.sink = this.budgetService.search(budgetQuery).subscribe({
                next: (result: any) => {
                    if (result.items.length > 1 || result.items.length === 0) {
                        listItem.wbseDescription = null;
                        if (listItem.isAftraPayment === "Y") {
                            aftraChild.wbseDescription = null;
                        }
                        if (
                            _.isEmpty(listItem.wbse) ||
                            _.isEmpty(_.trim(listItem.wbse)) ||
                            _.isEmpty(_.trim(listItem.wbseDescription))
                        ) {
                            const isWbseRequired = this.checkIfWBSERequired(listItem);
                            this.highlightField(
                                true,
                                this.field_wbse,
                                listItem.id,
                                (
                                    _.isEmpty(_.trim(listItem.wbse)) && 
                                    isWbseRequired
                                ) ? true : false
                            );
                        }
                    } else {
                        listItem.companyCode = budgetQuery.coCode;
                        listItem.wbseDescription = result.items[0].description;
                        this.setCompanyCode(
                            budgetQuery.coCode,
                            this.getListItemIndex(listItem.id)
                        );
                        this.highlightField(false, "wbse", listItem.id);
                        if (listItem.isAftraPayment === "Y") {
                            aftraChild.wbseDescription =
                                result.items[0].description;
                            this.highlightField(false, "wbse", aftraChild.id);
                        }
                    }
                },
                error: (err) => {
                    listItem.wbseDescription = null;
                    if (listItem.isAftraPayment === "Y") {
                        aftraChild.wbseDescription = null;
                    }
                },
            });
        } else {
            listItem.wbseDescription = null;
            if (listItem.isAftraPayment === "Y") {
                aftraChild.wbseDescription = null;
            }
            const isWbseRequired = this.checkIfWBSERequired(listItem);
            this.highlightField(
                isWbseRequired ? true : false,
                this.field_wbse,
                listItem.id,
                true
            );
        }
    }

    /*
     *Per requirement, it is necessary to have WBSE and CompanyCodes in sync. We have been asked to change company code when we select different wbse.
     */
    setCompanyCode(companyCode, itemIndex) {
        const lookupObj = {
            id: companyCode,
            name: "",
            description: companyCode,
        };
        this.modifiedListItems[itemIndex].companyCode = lookupObj;
        this.setChanged(this.modifiedListItems[itemIndex]);
    }

    /**
     * Set Changed
     * @memberof score.directives.talentPayrollTimesheetGrid
     * @function setChanged
     * @param {jQuery Object} $el
     * @fires onChangedDataset
     * @returns {}
     * @private
     */
    setChanged(listItem) {
        if (
            !_.isUndefined(listItem.isRejectionDepartmentChanged) &&
            listItem.isRejectionDepartmentChanged
        ) {
            listItem.isChanged = false;
            _.unset(listItem, "isRejectionDepartmentChanged");
        } else listItem.isChanged = true;

        const changedListItems = this.getChangedListItems();

        this._eventBusService.emit(
            new EmitEvent("setChanged", "setChanged", changedListItems)
        );

        //we need to enable the select row checkbox for the row which has payroll status > pending approval or pending authorization
        if (
            this.isPayrollTimesheetSelectDisabled(listItem) &&
            !listItem.parentTimecard
        ) {
            listItem.canSelect = true;
        }
    }

    getChangedListItems() {
        return _.filter(this.modifiedListItems, { isChanged: true });
    }

    onContactSelected(data) {
        const listId = _.parseInt(data.id);
        const contact = data.contact;

        const itemIndex = this.getListItemIndex(listId);
        if (contact.flaggedByhr) {
            this._eventBusService.emit(
                new EmitEvent(
                    "grid:onContactSelected",
                    "showInvalidContactAlert",
                    null
                )
            );
        } else {
            this.modifiedListItems[itemIndex].contact = contact;
            this._eventBusService.emit(
                new EmitEvent(
                    "grid:onContactSelected",
                    "assignContact",
                    this.modifiedListItems[itemIndex]
                )
            );
        }
    }

    /*
     * Clones the existing timecards. Requirement : clone operations field only
     */
    onCloneTimecard(listId) {
        const item = this.getListItemById(listId);
        this._eventBusService.emit(
            new EmitEvent("grid:onCloneTimecards", "onCloneTimecards", [item])
        );
    }

    //TODO : NOT BEING USED. Handled from base controller using keys
    //onBulkClone (actionKey, selectedItemsList) {
    //  var isValidRequest = true;
    //  var recordsCannotClone = _.filter(selectedItemsList, (o) => {
    //    return o.businessValidation.canClone === false;
    //  });

    //  if (_.isEmpty(recordsCannotClone)) {
    //    $scope.$emit("onDeleteTimecard", selectedItemsList);
    //  }
    //  else {
    //    $scope.$emit("showBulkActionFailureMsg", actionKey, "this is msg", recordsCannotClone);
    //  }

    //}

    /**
     * Delete a timecard
     * Method will validate and deactivate the timcar.
     * Timecard can be deleted by the creating department only when it is open or unlocked by the department.
     */
    onTimecardDelete(listId) {
        const item = this.getListItemById(listId);
        if (item.businessValidation.canDelete) {
            item.isActive = false;
            this._eventBusService.emit(
                new EmitEvent("grid:onTimecardDelete", "onTimecardDelete", [
                    item,
                ])
            );
        }
    }

    onBulkDelete(actionKey, selectedItemsList) {
        const isValidRequest = true;
        const recordsCannotDelete = _.filter(selectedItemsList, (o) => {
            return o.businessValidation.canDelete === false;
        });

        if (_.isEmpty(recordsCannotDelete)) {
            _.forEach(selectedItemsList, function (item) {
                item.isActive = false;
            });
            this._eventBusService.emit(
                new EmitEvent(
                    "grid:onBulkDelete",
                    "onTimecardDelete",
                    selectedItemsList
                )
            );
        } else {
            const data = {
                msg: "This action can not be complete because you are not allowed to delete below timecard(s):",
                listItems: recordsCannotDelete,
            };
            this._eventBusService.emit(
                new EmitEvent(
                    "grid:onBulkDelete",
                    "showBulkActionFailureMsg",
                    data
                )
            );
        }
    }

    /*
     * Unlock workflow starts here.
     * Unlock can be done for the post-Queue timecards
     */
    onUnlockTimecard(listId) {
        //suraj --> changed logic during upgrade. Nov.15,2022
        const item = this.getListItemById(listId);
        _.each(item.timecardStatus, (o) => {
            if (o.tpmDepartment.id === this.buAccess.departmentId)
                o.hasChanged = true;
        });
        this._eventBusService.emit(
            new EmitEvent("grid:onBulkDelete", "onUnlockTimecard", item)
        );
    }

    onUpdateOnContactSelect(listItem) {
        const modifiedItemAfterSelect = [];
        if (!_.isEmpty(listItem) && listItem.id !== -999) {
            this.updateGridRow(listItem);
        }
    }

    setWorkflowStatus(key, index) {
        const listItem = this.modifiedListItems[index];

        if (!_.isEmpty(listItem.timecardStatus)) {
            const deptStatus = _.find(listItem.timecardStatus, (o) => {
                return o.tpmDepartment.description === _.toUpper(_.trim(key));
            });
            deptStatus.lastSubmittedBy = deptStatus.submittedBy;
            deptStatus.lastSubmittedOn = deptStatus.submittedOn;
            deptStatus.isSubmitted = true;
            deptStatus.isUnlocked = false;
            deptStatus.submittedBy = this.user.id;
            deptStatus.hasChanged = true;
            deptStatus.hasSubmitted = true;
            deptStatus.submittedOn = new Date();
        }
    }

    setRejectStatus(key, listItem) {
        const rejectstatus = _.find(listItem.rejectStatus, (o) => {
            return o.tpmDepartment.description === _.toUpper(_.trim(key));
        });
        if (rejectstatus) {
            rejectstatus.isSubmitted = true;
            rejectstatus.submittedBy = this.user.id;
        }
    }

    /*
     * SCOR-16468 - add save button against each timecard
     * Works similar to the 'Save' option on top of the grid
     */
    onTimecardSave($index, listId, key) {
        //to handle aftra child record, we need this array
        const itemsToSave = [];

        const item = _.find(this.modifiedListItems, { id: listId });
        itemsToSave.push(item); //record that is saved by user

        const aftra = this.getChildListItem(listId);
        if (aftra) {
            itemsToSave.push(aftra); //if record to be saved has an aftra child record, then add that as well to array
        }

        this.emitAnEvent(
            "grid:onTimecardSave",
            "onDraftSaveTimecard",
            itemsToSave
        );
    }

    onGlobalSubmit(selectedTimecards) {
        let isValidRequest = true;
        let isRequired = false;
        let isFutureActivity = false;
        let isAllSsoValid = true;
        let isAllPernerValid = true;
        const contactSSOMissed = [];
        const contactPerNerMissed = [];
        const errorMessages = [];

        _.forEach(selectedTimecards, (item) => {
            const index = _.findIndex(this.modifiedListItems, { id: item.id });
            //var isValid = this.validateRow(index); -- Fix for this JIRA SCOR-22684
            const isValid = this.doDataValidation(index);
            if (item.businessValidation.isFutureActivity) {
                isFutureActivity = true;
            }
            if (
                !item.businessValidation.isSSOValid &&
                this.buAccess.department === this.dept_Finance
            ) {
                isValidRequest = false;
                isAllSsoValid = false;
                if (!item.parentTimecard) {
                    contactSSOMissed.push(item.contact.fullName);
                }
            }
            if (
                !item.businessValidation.isPernerValid &&
                this.buAccess.department === this.dept_Finance
            ) {
                isValidRequest = false;
                isAllPernerValid = false;
                if (!item.parentTimecard) {
                    contactPerNerMissed.push(item.contact.fullName);
                }
            }
            if (!isValid) {
                isRequired = true;
                isValidRequest = false;
            }
        });

        if (isFutureActivity) {
            this.emitAnEvent(
                "grid:onGlobalSubmit",
                "onFutureActivitySubmit",
                null
            );
            return;
        }

        if (this.buAccess.department === this.dept_Finance && !isAllSsoValid) {
            errorMessages.push(
                contactSSOMissed.join(",") + " profile is missing SSO."
            );
        }
        if (
            !isAllPernerValid &&
            this.buAccess.department === this.dept_Finance
        ) {
            errorMessages.push(
                contactPerNerMissed.join(",") + " profile is missing Perner."
            );
        }
        if (isRequired) {
            errorMessages.push("Required fields are missing and/or invalid.");
        }

        if (isValidRequest) {
            const list = [];
            const deptKey = this.buAccess.department;
            _.forEach(selectedTimecards, (item) => {
                const index = _.findIndex(this.modifiedListItems, {
                    id: item.id,
                });
                this.setWorkflowStatus(
                    item.currentProcessingDepartment.description,
                    index
                );
                this.setRejectStatus(
                    item.currentProcessingDepartment.description,
                    item
                );
                list.push(item);
                if (item.isAftraPayment === "Y") {
                    //we need to take care of this in db
                    this.setWorkflowStatus(
                        item.currentProcessingDepartment.description,
                        this.getChildListItemIndex(item.id)
                    );
                    this.setRejectStatus(
                        item.currentProcessingDepartment.description,
                        this.getChildListItem(item.id)
                    );
                    list.push(this.getChildListItem(item.id));
                }
            });

            const data = {
                submittedDept: this.buAccess.department,
                timecards: selectedTimecards,
            };
            this.emitAnEvent(
                "grid:onDepartmentSubmit",
                "onSubmitTimecard",
                data
            );
        } else {
            _.forEach(errorMessages, (error) => {
                this.log.showError(error);
            });
        }
    }

    /**Submitting the records from the grid. All department will use same method*/
    onDepartmentSubmit(index, listId, key) {
        const listItem = this.getListItemById(listId);
        //valdiate the record
        const isValid = this.doDataValidation(index);
        if (isValid) {
            if (listItem.businessValidation.isFutureActivity) {
                this.emitAnEvent(
                    "grid:onDepartmentSubmit",
                    "onFutureActivitySubmit",
                    null
                );
            } else if (
                !listItem.businessValidation.isSSOValid &&
                this.buAccess.department === this.dept_Finance
            ) {
                this.log.showError(
                    listItem.contact.fullName + " profile is missing SSO."
                );
            } else if (
                !listItem.businessValidation.isPernerValid &&
                this.buAccess.department === this.dept_Finance
            ) {
                this.log.showError(
                    listItem.contact.fullName + " profile is missing Perner."
                );
            } else {
                this.setWorkflowStatus(key, index);
                this.setRejectStatus(key, listItem);
                const list = [listItem];

                if (listItem.isAftraPayment === "Y") {
                    this.setWorkflowStatus(
                        key,
                        this.getChildListItemIndex(listId)
                    );
                    this.setRejectStatus(key, this.getChildListItem(listId));
                    list.push(this.getChildListItem(listId));
                }

                const data = {
                    submittedDept: key,
                    timecards: list,
                };
                this.emitAnEvent(
                    "grid:onDepartmentSubmit",
                    "onSubmitTimecard",
                    data
                );
            }
        } else {
            this.log.clearAlert();
            this.log.showError("Required fields are missing and/or invalid.");
        }
    }

    doDataValidation(index) {
        let isValid = this.validateRow(index);
        const item = this.modifiedListItems[index];
        const aftraRecord = this.getChildListItem(item.id);

        if (aftraRecord) {
            if (aftraRecord.aftraPercentage === "0") {
                isValid = false;
                this.log.showError("Aftra Pecentage is invalid.");
            } else {
                const childIndex = _.findIndex(this.modifiedListItems, {
                    id: aftraRecord.id,
                });
                isValid = this.validateRow(childIndex);
            }
        }

        return isValid;
    }

    validateRow(index) {
        let isValid = true;

        //get mandatory fields based on logged in user
        if (index === null || index === undefined) {
            return false;
        }

        //get mandatory fields for the logged in dept access
        this.getMandatoryFields();

        //get an item be be validaetd
        const item = this.modifiedListItems[index];
        if (item.payrollProvider) {
            item.payrollProvider.id =
                item.payrollProvider && item.payrollProvider.id === "null"
                    ? null
                    : item.payrollProvider.id;
        }

        //Setting Condition For Special Taxation
        if (
            item.employeeType?.id === "DHST" &&
            this.buAccess.department === this.dept_Finance
        ) {
            item.businessValidation.isRateValid = true;
            item.businessValidation.isWBSEValid = true;
            item.businessValidation.isGlAccountRequired = true;
        }

        _.forOwn(this.mandatoryConfig, (value, key) => {
            switch (key) {
                case this.field_firstName:
                    if (item.contact.firstName === "") {
                        isValid = false;
                        this.highlightField(true, "firstName", item.id);
                    } else {
                        this.highlightField(false, "firstName", item.id);
                    }
                    break;
                //check if date exists and is valid
                case this.field_activityDate:
                    //suraj:changed condition for date invalidity Nov,152022
                    //new Date(item[this.field_activityDate]) !== "Invalid Date"
                    if (
                        !(
                            item[this.field_activityDate] &&
                            new Date(
                                item[this.field_activityDate]
                            ).toString() !== "Invalid Date"
                        )
                    ) {
                        isValid = false;
                        this.highlightField(true, key, item.id);
                    } else {
                        this.highlightField(false, key, item.id);
                    }
                    break;

                case this.field_customRate:
                    if (this.buAccess.department === this.dept_Operation) {
                        if (
                            this.compareCustomRate(item[key], 0) &&
                            !this.hasTalentDepartment &&
                            item.businessValidation.isRateValid
                        ) {
                            isValid = false;
                            this.highlightField(true, key, item.id);
                        } else {
                            this.highlightField(false, key, item.id);
                        }
                    } else {
                        if (
                            this.compareCustomRate(item[key], 0) &&
                            item.businessValidation.isRateValid
                        ) {
                            isValid = false;
                            this.highlightField(true, key, item.id);
                        } else {
                            this.highlightField(false, key, item.id);
                        }
                    }
                    break;

                case this.field_eventShowName:
                    if (_.isEmpty(item[key]) && _.isEmpty(_.trim(item[key]))) {
                        isValid = false;
                        this.highlightField(true, key, item.id);
                    } else {
                        this.highlightField(false, key, item.id);
                    }
                    break;
                case this.field_glAccount:
                    if (
                        _.isEmpty(item[key]) &&
                        _.isEmpty(_.trim(item[key])) &&
                        item.businessValidation.isGLAccountRequired
                    ) {
                        isValid = false;
                        this.highlightField(true, key, item.id);
                    } else {
                        this.highlightField(false, key, item.id);
                    }
                    break;

                case this.field_employeeType:
                    if (!item[key] || (_.isEmpty(item[key].id) && !_.isNumber(item[key].id))) {
                        isValid = false;
                        this.highlightField(true, key, item.id);
                    } else {
                        this.highlightField(false, key, item.id);
                    }
                    if (item.businessValidation.isWorkStateValidation) {
                        if (
                            !item.stateContactWorked ||
                            !item.stateContactWorked.id
                        ) {
                            isValid = false;
                            this.highlightField(
                                true,
                                this.field_stateContactWorked,
                                item.id
                            );
                        } else {
                            this.highlightField(
                                false,
                                this.field_stateContactWorked,
                                item.id
                            );
                        }
                    }
                    if (item.businessValidation.isRateValid) {
                        if (
                            this.compareCustomRate(item.customRate, 0) ||
                            this.compareCustomRate(item.customRate, "0.00")
                        ) {
                            isValid = false;
                            this.highlightField(
                                true,
                                this.field_customRate,
                                item.id
                            );
                        } else {
                            this.highlightField(
                                false,
                                this.field_customRate,
                                item.id
                            );
                        }
                    }

                    if (
                        item.businessValidation.isWBSEValid &&
                        this.buAccess.department !== this.dept_Operation
                    ) {
                        if (item.isWbse) {
                            // wbse is valid if user has selected from wbse modal. Selection will provide description too. Keyed in WBSE wont have description
                            if (
                                _.isEmpty(item.wbse) ||
                                _.isEmpty(_.trim(item.wbse)) ||
                                _.isEmpty(_.trim(item.wbseDescription))
                            ) {
                                const isWbseRequired = this.checkIfWBSERequired(item);
                                isValid = false;
                                this.highlightField(
                                    true,
                                    this.field_wbse,
                                    item.id,
                                    (
                                        _.isEmpty(_.trim(item.wbse)) && 
                                        isWbseRequired
                                    ) ? true : false
                                );
                            } else {
                                this.highlightField(
                                    false,
                                    this.field_wbse,
                                    item.id
                                );
                            }
                        } else if (item.isCostCenter) {
                            if (
                                _.isEmpty(item[this.field_costCenter]) &&
                                _.isEmpty(_.trim(item[this.field_costCenter]))
                            ) {
                                isValid = false;
                                this.highlightField(
                                    true,
                                    this.field_costCenter,
                                    item.id
                                );
                            } else {
                                this.highlightField(
                                    false,
                                    this.field_costCenter,
                                    item.id
                                );
                            }
                        }
                    }
                    if (
                        item.businessValidation.isGLAccountRequired &&
                        this.buAccess.department !== this.dept_Operation
                    ) {
                        if (
                            _.isEmpty(item.glAccount) &&
                            _.isEmpty(_.trim(item.glAccount))
                        ) {
                            isValid = false;
                            this.highlightField(
                                true,
                                this.field_glAccount,
                                item.id
                            );
                        } else {
                            this.highlightField(
                                false,
                                this.field_glAccount,
                                item.id
                            );
                        }
                    }
                    break;

                case this.field_network:
                    if (!item[key] || (_.isEmpty(item[key].id) && !_.isNumber(item[key].id))) {
                        isValid = false;
                        this.highlightField(true, key, item.id);
                    } else {
                        this.highlightField(false, key, item.id);
                    }
                    break;
                case this.field_dayType:
                    if (!item[key] || (_.isEmpty(item[key].id) && !_.isNumber(item[key].id))) {
                        isValid = false;
                        this.highlightField(true, key, item.id);
                    } else {
                        this.highlightField(false, key, item.id);
                    }
                    break;

                //SCOR - 15775
                case this.field_wageType:
                    //if (item.payrollProvider.id === "SPB" || checkIfWageTypeEnabled(item) && item.businessValidation.isFinanceFieldEnabled && (BuAccess.department === dept_Finance || BuAccess.department === dept_Payroll)) {
                    if (
                        item.payrollProvider &&
                        item.payrollProvider.id === "SPB" &&
                        item.businessValidation.isFinanceFieldEnabled &&
                        this.buAccess.department === this.dept_Payroll
                    ) {
                        if (
                            _.isEmpty(item[key]) &&
                            _.isEmpty(_.trim(item[key]))
                        ) {
                            isValid = false;
                            this.highlightField(true, key, item.id);
                        } else {
                            this.highlightField(false, key, item.id);
                        }
                    } else {
                        this.highlightField(false, key, item.id);
                    }
                    break;

                case this.field_wageschedule:
                    //if (item.payrollProvider.id === "SPB" || checkIfWageTypeEnabled(item) && item.businessValidation.isFinanceFieldEnabled && (BuAccess.department === dept_Finance || BuAccess.department === dept_Payroll)) {
                    if (
                        item.payrollProvider &&
                        item.payrollProvider.id === "SPB" &&
                        item.businessValidation.isFinanceFieldEnabled &&
                        this.buAccess.department === this.dept_Payroll
                    ) {
                        if (
                            _.isEmpty(item[key]) &&
                            _.isEmpty(_.trim(item[key]))
                        ) {
                            isValid = false;
                            this.highlightField(true, key, item.id);
                        } else {
                            this.highlightField(false, key, item.id);
                        }
                    } else {
                        this.highlightField(false, key, item.id);
                    }
                    break;

                case this.field_payrollProvider:
                    var lookupKey = key + ".id";
                    if (!item[key] && !item[key]?.id) {
                        isValid = false;
                        this.highlightField(true, key, item.id);
                    } else {
                        this.highlightField(false, key, item.id);
                    }
                    break;

                case this.field_contractCode:
                    if (
                        _.isEmpty(item[key]) &&
                        item.payrollProvider?.id === "TK"
                    ) {
                        isValid = false;
                        this.highlightField(true, key, item.id);
                    } else {
                        if (
                            !_.isEmpty(item[key]) &&
                            _.isEmpty(item[key].name) &&
                            item.payrollProvider &&
                            item.payrollProvider.id === "TK"
                        ) {
                            isValid = false;
                            this.highlightField(true, key, item.id);
                        } else {
                            this.highlightField(false, key, item.id);
                        }
                    }
                    break;

                case this.field_payTransactions:
                    if (
                        _.isEmpty(item[key]) &&
                        item.payrollProvider &&
                        item.payrollProvider.id === "TK"
                    ) {
                        isValid = false;
                        this.highlightField(true, key, item.id);
                    } else {
                        this.highlightField(false, key, item.id);
                    }
                    break;

                case this.field_jobCode:
                    if (
                        _.isEmpty(item[key]) &&
                        _.isEmpty(_.trim(item[key])) &&
                        item.payrollProvider &&
                        item.payrollProvider.id === "TK"
                    ) {
                        isValid = false;
                        this.highlightField(true, key, item.id);
                    } else {
                        this.highlightField(false, key, item.id);
                    }
                    break;

                case this.field_wbse:
                case this.field_costCenter:
                    //we may have wbse or cost center
                    //if (item.isWbse) {
                    //    // wbse is valid if user has selected from wbse modal. Selection will provide description too. Keyed in WBSE wont have description
                    //    if ((_.isEmpty(item[key]) || (_.isEmpty(_.trim(item[key])) || _.isEmpty(_.trim(item.wbseDescription)))) && item.businessValidation.isWBSEValid) {
                    //        isValid = false;
                    //        this.highlightField(true, key, item.id);
                    //    } else {
                    //        this.highlightField(false, key, item.id);
                    //    }
                    //}
                    //else if (item.isCostCenter) {
                    //    if (_.isEmpty(item[field_costCenter]) && _.isEmpty(_.trim(item[field_costCenter])) && item.businessValidation.isWBSEValid) {
                    //        isValid = false;
                    //        this.highlightField(true, field_costCenter, item.id);
                    //    } else {
                    //        this.highlightField(false, field_costCenter, item.id);
                    //    }
                    //}
                    break;
            }
        });

        return isValid;
    }

    onAftraAmountChanged(index, changedValue) {
        this.updateListItem(index, "aftraAmount", changedValue);
    }

    onAftraSplit(listId) {
        const listItem = this.getListItemById(listId);
        listItem.companyCode = listItem.companyCode?.id;
        if (listItem.isAftraPayment !== "Y") {
            listItem.isAftraPayment = "C";
        }

        listItem.disableAftraAfterSplit = true;
        this.emitAnEvent("grid:onAftraSplit", "onSplitAftraTimecard", listItem);
    }

    onAftraMerge(listId) {
        const timesheets = [];
        const item = this.getListItemById(listId);
        item.isAftraPayment = "N";
        item.aftraPercentage =
            parseInt(item.aftraPercentage, 10) === 100
                ? item.aftraPercentage
                : null;
        item.aftraAmount = null;
        timesheets.push(item);
        //get child aftra payment
        const childItem = this.getChildListItem(item.id);
        if (childItem) {
            childItem.isActive = false;
            childItem.aftraPercentage = null;
            childItem.aftraAmount = null;
            timesheets.push(childItem);
        }
        _.each(timesheets, (timesheet) => {
            if (
                timesheet.companyCode &&
                typeof timesheet.companyCode === "object"
            )
                timesheet.companyCode = timesheet.companyCode
                    ? timesheet.companyCode.description
                    : timesheet.companyCode;
        });

        this.emitAnEvent(
            "grid:onAftraMerge",
            "onMergeAftraTimecard",
            timesheets
        );
    }

    onUnauthorizedTimecard(listId, key) {
        const itemToUnauthorize = []; //SCOR-22189 - sending an array rather than an TC object as receiver requires this format

        const listItem = this.getListItemById(listId);
        itemToUnauthorize.push(listItem);
        const data = {
            listItem: itemToUnauthorize,
            key: key,
        };

        this.emitAnEvent(
            "grid:onUnauthorizedTimecard",
            "onUnauthorizedTimecard",
            data
        );
    }

    onRejectTimecard(listId, key) {
        const itemToReject = []; //SCOR-22267 ; backend expects an array rather than a single TC object; hence passing as an arrary
        const listItem = this.getListItemById(listId);
        itemToReject.push(listItem);
        const data = {
            listItem: itemToReject,
            key: key,
        };
        this.emitAnEvent("grid:onRejectTimecard", "spbRejectTimecard", data);
    }

    onTimecardRejectWithReason(data) {
        this.emitAnEvent(
            "grid:onTimecardRejectWithReason",
            "timecardReject",
            data
        );
    }

    compareCustomRate(rate, compareRate) {
        let isEqualRate = false;
        if (!rate) rate = 0.0;
      if (this.isValidNumber(rate)) {
        let val1;
        let val2;
        if (typeof rate === 'string') {
          val1 = parseFloat(rate.replace(/,/g, '')).toFixed(2);
        }
        else {
          val1 = parseFloat(rate).toFixed(2);
        }

        if (typeof compareRate === 'string') {
          val2 = parseFloat(compareRate.replace(/,/g, '')).toFixed(2);
        }
        else {
          val2 = parseFloat(compareRate).toFixed(2);
        }
        //const val1 = parseFloat(rate).toFixed(2);
        //const val2 = parseFloat(compareRate).toFixed(2);
        if (val1 === val2) isEqualRate = true;

        }
        return isEqualRate;
    }

    isValidNumber(number) {
        let isValid = true;
        if (_.isNaN(_.parseInt(number, 10))) {
            isValid = false;
        }
        return isValid;
    }

    onBlurDatavalidation(index) {
        //valdiate the record
        const isValid = this.doDataValidation(index);
    }

    highlightField(setHighlight, key, id, isWbseValid = true) {
        setTimeout(() => {
            const validation_selector = "#" + key + "-validationmsg-" + id;
            // let field_selector = "[name='" + key + "-" + id + "']";
            const field_selector = "#" + key + "-" + id;

            const $span = this._document.querySelector(validation_selector);
            let field = this._document.querySelector(field_selector);
            if (field?.tagName == "NBC-SELECT") field = field.parentElement;

            if(key == "wbse")
            {
                if (!isWbseValid) {
                    $span.innerHTML = "wbse missing and/or invalid.";
                } else {
                    $span.innerHTML = "Required";
                }
            }

            if (setHighlight) {
                if ($span) $span.classList.remove("d-none");
                //suraj: commemnted the condition as remove will work if string exists. Nov.15,2022
                ////show msg
                //if ($span.classList.contains("hide")) {
                //  $span.classList.remove("hide");
                //}

                //suraj: commented the condition. JS will take care if already exists. Nov.15, 2022
                if (field) field.classList.add("required-field");
                ////highlight the field
                //if (!$span.hasClass("required-field")) {
                //  field.addClass("required-field");
                //}
            } else {
                if ($span) $span.classList.add("d-none");
                if (field) field.classList.remove("required-field");
            }
        }, 100);
    }

    onSelectAllRecordsChange(isSelectAllChecked) {
        let itemsSelected = false;
        _.forEach(this.modifiedListItems, (item) => {
            if (item.businessValidation.canSelect) {
                item.selected = isSelectAllChecked;
                itemsSelected = true;
            }
        });

        if (itemsSelected && isSelectAllChecked)
            this.emitAnEvent(
                "grid:onSelectAllRecordsChange",
                "toggleBulkUpdateMenuBasedOnCheckboxState",
                this.modifiedListItems
            );
        else
            this.emitAnEvent(
                "grid:onSelectAllRecordsChange",
                "toggleBulkUpdateMenuBasedOnCheckboxState",
                []
            );
    }

    onSelectPosition(listIndex) {
        let isAllRowsSelected = false;

        this.modifiedListItems[listIndex].selected =
            !this.modifiedListItems[listIndex].selected;
        const selectedItems = _.filter(this.modifiedListItems, {
            selected: true,
        });

        let aftraRecordCount = 0;
        if (selectedItems) {
            _.forEach(selectedItems, (item) => {
                if (item.isAftraPayment === "Y") {
                    const aftraRecord = _.find(this.modifiedListItems, {
                        parentTimecard: item.id,
                    });
                    selectedItems.push(aftraRecord);
                    aftraRecordCount++;
                }
            });
        }

        const recordsWithEnabledCheckBox = _.filter(
            this.modifiedListItems,
            (item) => {
                return item.businessValidation.canSelect == true;
            }
        );
        if (
            selectedItems?.length - aftraRecordCount ===
            recordsWithEnabledCheckBox?.length
        )
            isAllRowsSelected = true;

        this.emitAnEvent(
            "grid:onSelectPosition",
            "onAllRecordsSelected",
            isAllRowsSelected
        );

        if (selectedItems.length > 0) {
            this.emitAnEvent(
                "onSelectPosition",
                "toggleBulkUpdateMenuBasedOnCheckboxState",
                selectedItems
            );
        } else
            this.emitAnEvent(
                "onSelectPosition",
                "toggleBulkUpdateMenuBasedOnCheckboxState",
                []
            );
    }

    bulkUpdate(data) {
        const listItems = data.listItems,
            prop = data.key,
            newVal = data.value;

        switch (prop) {
            case this.field_activityDate:
                newVal[prop] = moment(newVal[prop]).format("L");
                this.bulkUpdateSingleFields(listItems, prop, newVal);
                break;
            case this.field_glAccount:
            case this.field_eventShowName:
            case this.field_hoursWorked:
            case this.field_customRate:
                this.bulkUpdateSingleFields(listItems, prop, newVal);
                break;

            case this.field_contractCode:
                this.bulkUpdateContractCode(listItems, prop, newVal);
                break;

            case this.field_jobCode:
                this.bulkUpdateJobCode(listItems, newVal);
                break;

            case this.field_employeeType:
                this.onBulkEmployeeTypeChange(listItems, prop, newVal[prop]);
                break;
            case this.field_dayType:
            case this.field_network:
            case this.field_sport:
                //var selectorKey = "." + prop + "-el";
                /*Method do not hold any workflow logic.*/
                this.onBulkDropDownUpdate(listItems, prop, newVal[prop]);
                break;

            case this.field_costCenter:
                this.bulkUpdateCostCenterChange(listItems, newVal);
                break;

            case this.field_payrollProvider:
                this.bulkUpdatePayrollProvider(listItems, prop, newVal[prop]);
                break;

            case this.field_stateContactWorked:
                this.onBulkUpdateStateContactWorked(
                    listItems,
                    newVal.workstate
                );
                break;

            case this.field_unioncode:
                this.onBulkUpdateUnionCodeChanged(
                    listItems,
                    prop,
                    newVal[prop]
                );
                break;

            case this.field_wageType:
                this.onBulkUpdateWageType(listItems, prop, newVal[prop]);
                break;
            case this.field_wageschedule:
                this.onBulkUpdatewageschedule(listItems, prop, newVal[prop]);
                break;

            case this.field_payrollCostCenter:
                this.bulkUpdatePayrollCostCenterChange(listItems, newVal);
                break;

            default:
                throw new Error("Unrecognized bulk update property.");
        }
    }

    /**
     * Bulk Action
     * @param {Object} event event
     * @param {payrollTimesheet} listItems
     * @param {String} prop
     * @param {Object} newVal
     * @private
     * @function bulkAction
     */
    bulkAction(data) {
        const listItems = data.listItems,
            prop = data.key,
            newVal = data.value;

        switch (prop) {
            case "multiTimecards":
                break;
            case "deleteTimecard":
                this.onBulkDelete(prop, listItems);
                break;
            case "cloneTimecard":
                break;
            case "createTemplate":
                break;
            case "appendTemplate":
                break;
            default:
                throw new Error("Unrecognized bulk update property.");
        }
    }

    /**
     * Bulk Update Single Fields
     * @memberof score.directives.talentPayrollTimesheetGrid
     * @param {payrollTimesheet} listItems
     * @param {Object} prop
     * @param {Object} newVal
     * @returns {}
     * @private
     */
    bulkUpdateSingleFields(listItems, prop, newVal) {
        let i, index, id, $row;

        for (i = 0; i < listItems.length; i += 1) {
            id = listItems[i].id;
            index = this.getListItemIndex(id);

            if (this.modifiedListItems && index > -1) {
                this.modifiedListItems[index][prop] = newVal[prop];

                if (prop === "activityDate") {
                    // SCOR-16764: TPM - Allow user to submit TC with 'Date Worked' up to and including Saturday
                    this.modifiedListItems[
                        index
                    ].businessValidation.isFutureActivity =
                        moment(this.modifiedListItems[index].activityDate) >
                        moment().endOf("week");
                }

                this.setChanged(this.modifiedListItems[index]);
            }
        }
    }

    /**
     * Bulk Update Contract Codes
     * @memberof score.directives.talentPayrollTimesheetGrid
     * @param {payrollTimesheet} listItems
     * @param {Object} prop
     * @param {Object} newValues
     * @returns {}
     */
    bulkUpdateContractCode(listItems, prop, newValues) {
        let i, index, id, listItem, previousContractCode, newContractCode;

        for (i = 0; i < listItems.length; i += 1) {
            id = listItems[i].id;
            index = this.getListItemIndex(id);

            if (this.modifiedListItems && index > -1) {
                listItem = this.modifiedListItems[index];
                previousContractCode = _.cloneDeep(listItem.contractCode);
                newContractCode = newValues.contractCode;

                _.set(listItem, this.field_payTransactions, []);
                listItem.hasPaytransactionChanged = true;

                if (id > 0 && newContractCode && listItem) {
                    //this.setContractCodesUpdatesOnChange(listItem, newContractCode, false, null);
                    //TODO: NOT NEEDED:CONFIRM AND DELETE
                    //$("[name='payrolladdtransactions-" + listItem.id + "']").removeClass("hidden");
                    //$("[name='btnpayrolltransactions-" + listItem.id + "']").removeAttr("disabled");
                } else {
                    listItem.contractCode = null;

                    //TODO: NOT NEEDED:CONFIRM AND DELETE
                    //$("[name='btnpayrolltransactions-" + listItem.id + "']").attr("disabled", "disabled");
                }

                if (
                    previousContractCode &&
                    newContractCode &&
                    previousContractCode.name !== newContractCode.name
                ) {
                    listItem.payIndicators = [];
                }

                this.setContractCodesUpdatesOnChange(
                    listItem,
                    newContractCode,
                    true,
                    newValues
                );
                this.checkPayrollDefaults(listItem, "ContractCode");
            }
        }
    }

    /**
     * Sets Contract Codes Update on Change
     * @memberof score.directives.talentPayrollTimesheetGrid
     * @function setContractCodesUpdatesOnChange
     * @param {contractCode} contractCode
     * @returns {}
     * @private
     */
    setContractCodesUpdatesOnChange(
        listItem,
        contractCode,
        isBulk,
        newContractCodeValues
    ) {
        let id,
            index,
            ruleVariance,
            payTransactions,
            indicators,
            oldContractCode;

        if (contractCode) {
            if (listItem) {
                oldContractCode = listItem.contractCode;
                id = listItem.id;
                index = this.getListItemIndex(id);

                listItem = this.setContractCode(
                    listItem,
                    contractCode,
                    newContractCodeValues || null
                );

                if (
                    newContractCodeValues &&
                    contractCode.name !==
                        newContractCodeValues.contractCode?.name
                ) {
                    listItem.payTransactions = [];
                }
                if (isBulk) {
                    ruleVariance = newContractCodeValues?.ruleVariance || null;
                    payTransactions =
                        newContractCodeValues?.payTransactions || null;
                    indicators = newContractCodeValues?.indicators || null;
                } else {
                    ruleVariance = null;
                    payTransactions = null;
                    indicators = null;
                }

                listItem = this.setTransactionTypes(
                    listItem,
                    contractCode,
                    payTransactions,
                    oldContractCode
                );

                this.modifiedListItems[index] = listItem;
                this.setChanged(listItem);
            }
        }
    }

    /**
     * Sets Transaction Types
     * @memberof score.directives.talentPayrollTimesheetGrid
     * @function setTransactionTypes
     * @param {payrollTimesheet} listItem
     * @param {contractCode} contractCode
     * @returns {payrollTimesheet}
     * @private
     */
    setTransactionTypes(
        listItem,
        contractCode,
        payTransactions,
        oldContractCode
    ) {
        let i, transactionType;

        if (listItem && contractCode) {
            listItem.transactionTypes = contractCode.transactionTypes;
            listItem.transactionTypes = _.orderBy(
                listItem.transactionTypes,
                ["description"],
                ["asc"]
            );
            if (listItem.isApproved) {
                listItem.transactionTypes =
                    this.removeInvalidPayTransactionsIfApproved(
                        listItem.transactionTypes
                    );
            }

            if (payTransactions) {
                if (!listItem.payTransactions) {
                    listItem.payTransactions = [];
                }

                if (
                    contractCode &&
                    oldContractCode &&
                    contractCode.name !== oldContractCode.name
                ) {
                    listItem.payTransactions = _.cloneDeep(payTransactions);
                } else {
                    for (i = 0; i < payTransactions.length; i += 1) {
                        transactionType = payTransactions[i];

                        if (
                            this.isOlyMinCall(transactionType.transactionCode)
                        ) {
                            if (!listItem.isApproved) {
                                listItem.payTransactions.push(transactionType);
                            }
                        } else {
                            listItem.payTransactions.push(transactionType);
                        }
                    }
                }
            }

            this.setPayTransactions(listItem);
        }
        return listItem;
    }

    onUpdatePayTransactions(listItem) {
        listItem.hasPaytransactionChanged = true; //SCOR-22208
        this.updateGridRow(listItem);
    }

    /**
     * Set Pay Transactions
     * @memberof score.directives.talentPayrollTimesheetGrid
     * @function setPayIndicators
     * @param {payrollTimesheets} listItem
     * @returns {}
     * @private
     */
    setPayTransactions(listItem) {
        //TODO: NOT NEEDED:CONFIRM AND DELETE

        //if (listItem.payTransactions && listItem.payTransactions.length > 0) {
        //  $("#payTransactions-validationmsg-" + listItem.id + "").addClass("hidden");
        //  $("[name='payrolladdtransactions-" + listItem.id + "']").addClass("hidden");
        //  $("[name='edit-transactions-" + listItem.id + "']").removeClass("hidden")
        //    .find(".transaction-count")
        //    .text(listItem.payTransactions.length + " transaction" + (listItem.payTransactions.length > 1 ? "s" : ""));
        //  $("[name='payTransaction-" + listItem.id + "']").val(true);
        //} else {
        //  $("#payTransactions-validationmsg-" + listItem.id + "").removeClass("hidden");
        //  $("[name='payrolladdtransactions-" + listItem.id + "']").removeClass("hidden");
        //  $("[name='edit-transactions-" + listItem.id + "']").addClass("hidden");
        //  $("[name='payTransaction-" + listItem.id + "']").val("");
        //}

        //TODO: NOT NEEDED:CONFIRM AND DELETE
        //$("[name='transaction-dirty-" + listItem.id + "']").val("changed").change();
        this.setChanged(listItem);
    }

    addPayTransaction(id) {
        this.emitAnEvent(
            "grid:addPayTransaction",
            "onOpenPayTransaction",
            this.getListItemById(id)
        );
    }

    removeInvalidPayTransactionsIfApproved(transactionTypes) {
        return transactionTypes.filter((transactionType) => {
            return !this.isOlyMinCall(transactionType.description);
        });
    }

    isOlyMinCall(transactionCode) {
        return transactionCode.toUpperCase() === "OLYMINCALL";
    }

    /**
     * Sets Contract Code
     * @memberof score.directives.talentPayrollTimesheetGrid
     * @param {payrollTimesheet} listItem
     * @param {contractCode} contractCode
     * @param {Object} newValue
     * @returns {}
     * @private
     */
    setContractCode(listItem, contractCode, newValue) {
        if (contractCode) {
            listItem.contractCode = {
                id: contractCode.id,
                name: contractCode.name,
            };

            //TODO: Remove when not required
            //if (newValue) {
            //  $el.find(contractCodeSelector).val(newValue.id);
            //}
        }

        return listItem;
    }

    /**
     * Bulk Update Job Code, Rate Code (and sometimes Custom Rate)
     * @memberof score.directives.talentPayrollTimesheetGrid
     * @param {payrollTimesheet} listItems
     * @param {Object} newValues
     * @returns {}
     * @private
     */
    bulkUpdateJobCode(listItems, newValues) {
        let $row,
            i,
            index,
            id,
            JOB_CODE = this.field_jobCode,
            JOB_CODE_DETAIL = "jobCodeDetail",
            RATE_CODE = "rateCode",
            CUSTOM_RATE = this.field_customRate;

        for (i = 0; i < listItems.length; i += 1) {
            id = listItems[i].id;
            index = this.getListItemIndex(id);

            if (index > -1) {
                if (
                    newValues &&
                    newValues.hasOwnProperty(JOB_CODE) &&
                    newValues[JOB_CODE]
                ) {
                    //$row.find("[data-field='" + JOB_CODE + "']").val(newValues[JOB_CODE].code);
                    this.changeJobCode(index, newValues[JOB_CODE]);
                }

                if (
                    newValues &&
                    newValues.hasOwnProperty(RATE_CODE) &&
                    newValues[JOB_CODE]
                ) {
                    //$row.find("[data-field='" + JOB_CODE_DETAIL + "']").val(newValues[RATE_CODE].rateCode);
                    this.changeRateCode(index, newValues[RATE_CODE]);
                }
            }
        }
    }

    /**
     * Changes the job code and anything that depends on it
     * @memberof score.directives.talentPayrollTimesheetGrid
     * @function changeJobCode
     * @param {number} index
     * @param {Object} jobCode
     * @returns {}
     * @private
     */
    changeJobCode(index, jobCode) {
        if (
            index > -1 &&
            jobCode.code !== undefined &&
            jobCode &&
            jobCode.details
        ) {
            //TODO: NOT NEEDED:CONFIRM AND DELETE
            //setDropdowns($row.find(rateCodeSelector), jobCode.details, "rateCode", "rateCode", false, DEFAULT_RATE_CODE);
            //$row.find(customCodeSelector).removeClass("hidden");

            this.modifiedListItems[index].jobCode = jobCode.code;
            this.modifiedListItems[index].rateCode = this.DEFAULT_RATE_CODE;
            this.modifiedListItems[index].jobCode =
                jobCode.code + this.DEFAULT_RATE_CODE;
            this.modifiedListItems[index].jobCodeDetail = jobCode.details[0];
            this.modifiedListItems[index].selectedJobCode = jobCode.code;
        }

        this.setChanged(this.modifiedListItems[index]);
    }

    /**
     * Changes the rate code and anything that depends on it
     * @memberof score.directives.talentPayrollTimesheetGrid
     * @function changeRateCode
     * @param {number} index
     * @param {Object} jobCodeDetail
     * @returns {}
     * @private
     */
    changeRateCode(index, jobCodeDetail) {
        if (jobCodeDetail) {
            //TODO: NOT NEEDED:CONFIRM AND DELETE
            //if (jobCodeDetail.rateCode === this.DEFAULT_RATE_CODE) {
            //  $row.find(customCodeSelector).removeClass("hidden");
            //} else {
            //  $row.find(customCodeSelector).addClass("hidden");
            //}

            this.modifiedListItems[index].jobCode = jobCodeDetail.code;
            this.modifiedListItems[index].rateCode = jobCodeDetail.rateCode;
            this.modifiedListItems[index].jobCodeDetail = jobCodeDetail;
            this.setChanged(this.modifiedListItems[index]);
        }
    }

    onBulkEmployeeTypeChange(listItems, prop, value) {
        _.forEach(listItems, (item) => {
            // let lookupObj = { id: value, name: "", description: "" };
            item[prop] = value;

            //TODO: NOT NEEDED:CONFIRM AND DELETE
            //setDropDownValue(item, prop, value, selector);
            this.postEmployeeTypeChange(item);
            const index = this.getListItemIndex(item.id);
            this.onBlurDatavalidation(index);
        });
    }

    /*
     * impact expected
     */
    onEmployeeTypeChange(index, data) {
        this.log.trace("employee type change");
        const item = this.modifiedListItems[index];
        this.postEmployeeTypeChange(item);
        this.checkContactValidation(item);
        if (item.isAftraPayment === "Y") {
            const childItem = this.getChildListItem(item.id);
            this.postEmployeeTypeChange(childItem);
            this.checkContactValidation(childItem);
            this.updateAftraChildRecord(item, "employeeType");
        }
    }

    postEmployeeTypeChange(item) {
        //work state disable enable

        this.fieldRequired(item);
        if (this.checkIfWorkStateEnabled(item)) {
            item.businessValidation.isWorkStateValidation = true;
            item.stateContactWorked = null;
        }
        if (!this.checkIfWorkStateEnabled(item)) {
            item.businessValidation.isWorkStateValidation = false;
            item.stateContactWorked = null;
            this.highlightField(false, "stateContactWorked", item.id);

            //TODO: NOT NEEDED:CONFIRM AND DELETE
            //setDropdowns($ele, workStates, "id", "id", true, null, true, "-Select-", null);
        } else {
            //TODO: NOT NEEDED:CONFIRM AND DELETE
            //setDropdowns($ele, workStates, "id", "id", true, null, true, "-Select-", null);
            item.stateContactWorked = null;
        }

        //default payroll provider. ONLY for PAYROLL
        if (this.buAccess.department === this.dept_Payroll) {
            const empDefaults = this.getDefaultsForEmpType(
                item.employeeType?.id
            );
            item.payrollProvider.id = empDefaults
                ? empDefaults.payrollDefault.provider
                : null;

            //TODO: NOT NEEDED:CONFIRM AND DELETE
            //var payrollProvider = this.getPayrollProviderEle(item.id);
            //payrollProvider.val(empDefaults ? empDefaults.payrollDefault.provider : null);

            this.tKFieldsAccessibility(item, item.payrollProvider.id);
        }
        this.checkPayrollDefaults(item, "EmployeeType");
        this.setChanged(item);
    }

    //Setting Payroll Default Onload
    setPayrollDefaultsonLoad(listItems: any) {
        let listItemIndex = 0;
        for (listItemIndex; listItemIndex < listItems.length; listItemIndex++) {
            const item = listItems[listItemIndex];
            if (
                item.currentProcessingDepartment &&
                item.currentProcessingDepartment.description === "PAYROLL" &&
                this.buAccess.department === this.dept_Payroll &&
                _.isEmpty(item.contractCode.name)
            ) {
                this.checkPayrollDefaults(item, "EmployeeType");
            }
        }
    }

    /*
     * The contract code and family are only related to TK. So, if payroll user selects other than TK, we need to disabled other fields.
     */
    tKFieldsAccessibility(item, value) {
        //var selector = tkProviderRelatedFieldSelector + "-" + item.id;
        let jobCodeIndex;
        if (item.unionCode.description) {
            jobCodeIndex = this.getJobCodeIndex(item.unionCode.description);
        } else {
            jobCodeIndex = _.findIndex(this.allJobCodes, {
                code: this.AftraUnionCodes[0],
            });
        }

        if (value && value.id === "TK") {
            //TODO: NOT NEEDED:CONFIRM AND DELETE
            //var $contractcodeEle = $("[name='contractCode-" + item.id + "']");
            //$(selector).removeAttr("disabled");
            //$contractcodeEle.addClass("required-outline");
            //$("[name='payrolladdtransactions-" + item.id + "']").addClass("required-outline");

            if (!item.contractCode) {
                _.set(item, this.field_payTransactions, []);
                item.hasPaytransactionChanged = true;

                //TODO: NOT NEEDED:CONFIRM AND DELETE
                //$("[name='payrolladdtransactions-" + item.id + "']").removeClass("hidden");
                //$("[name='btnpayrolltransactions-" + item.id + "']").attr("disabled", "disabled");
            } else {
                //TODO: NOT NEEDED:CONFIRM AND DELETE
                // $("[name='btnpayrolltransactions-" + item.id + "']").removeAttr("disabled");
            }

            //$("[name='jobCode-" + item.id + "']").addClass("required-outline");
            //$("[name='timeCardRate-" + item.id + "']").removeAttr("disabled");

            _.set(item, "rate", this.TIMECARDRATE_DEFAULT);

            //$("[name='timeCardRate-" + item.id + "']").val(TIMECARDRATE_DEFAULT);
            //_.set(item, "rateCode", DEFAULT_RATE_CODE);
        } else {
            //TODO: NOT NEEDED:CONFIRM AND DELETE
            //$(selector).attr("disabled", "disabled");
            //$(selector).removeClass("required-outline");
            //$("[name='contractCode-" + item.id + "']").removeClass("required-outline");
            //$("[name='payTransactions-" + item.id + "']").removeClass("required-outline");

            _.set(item, this.field_contractCode, null);
            _.set(item, this.field_payTransactions, []);

            //TODO: NOT NEEDED:CONFIRM AND DELETE
            //_.set(item, field_jobCode, allJobCodes[jobCodeIndex].code);
            //_.set(item, "rateCode", DEFAULT_RATE_CODE);

            //$("[name='payrolladdtransactions-" + item.id + "']").removeClass("hidden");
            //$("[name='btnpayrolltransactions-" + item.id + "']").attr("disabled", "disabled");
            item.hasPaytransactionChanged = true;

            //TODO: NOT NEEDED:CONFIRM AND DELETE
            //$("[name='jobCode-" + item.id + "']").removeClass("required-outline");
            //$("[name='timeCardRate-" + item.id + "']").attr("disabled", "disabled");
            //$("[name='timeCardRate-" + item.id + "']").val("");

            _.set(item, "rate", null);
        }

        //setDropDownValue(item, field_payrollProvider, value, payrollProviderSelector);
        //setPayTransactions($(rowSelector + item.id), item);

        //setDropdowns($("[name='contractCode-" + item.id + "']"), allContractCodes, "name", "id", true, null, true, "-Select-", null);

        item.jobcode =
            this.allJobCodes[jobCodeIndex].code + this.DEFAULT_RATE_CODE;
        item.jobCode =
            this.allJobCodes[jobCodeIndex].code + this.DEFAULT_RATE_CODE;

        //setDropDownValue(item, field_jobCode, allJobCodes[jobCodeIndex].code, jobCodeSelector);
        this.defaultJobCodeDetails(item, this.allJobCodes[jobCodeIndex]);

        //TODO: NOT NEEDED:CONFIRM AND DELETE
        //if (!_.isEmpty(item.jobCodeDetail)) {

        //  setDropdowns($("[name='jobCodeDetail-" + item.id + "']"), item.jobCodeDetail, "rateCode", "rateCode", true, "00", true, "00", null);
        //}
        //if (this.buAccess.department === this.dept_Payroll && item.payrollProvider.id === "SPB") {
        //  $("[name='wageType-" + item.id + "']").addClass("required-outline");
        //}
        //else {
        //  $("[name='wageType-" + item.id + "']").removeClass("required-outline");
        //}

        const aftra = this.getChildListItem(item.id);
        if (aftra) {
            let aftrajobCodeIndex;
            if (aftra.unionCode.description) {
                aftrajobCodeIndex = this.getJobCodeIndex(
                    item.unionCode.description
                );
            } else {
                aftrajobCodeIndex = _.findIndex(this.allJobCodes, {
                    code: this.AftraUnionCodes[0],
                });
            }

            //TODO: NOT NEEDED:CONFIRM AND DELETE
            //if (this.buAccess.department === this.dept_Payroll && aftra.payrollProvider.id === "SPB") {
            //  $("[name='wageType-" + aftra.id + "']").addClass("required-outline");
            //}
            //else {
            //  $("[name='wageType-" + aftra.id + "']").removeClass("required-outline");
            //}
            //setDropDownValue(aftra, field_payrollProvider, value, payrollProviderSelector);

            if (aftra.payrollProvider && aftra.payrollProvider.id === "TK") {
                //var $aftracontractcodeEle = $("[name='contractCode-" + aftra.id + "']");
                if (!aftra.contractCode) {
                    _.set(aftra, this.field_payTransactions, []);
                    aftra.hasPaytransactionChanged = true;
                    //$("[name='payrolladdtransactions-" + aftra.id + "']").removeClass("hidden");
                    //$("[name='btnpayrolltransactions-" + aftra.id + "']").attr("disabled", "disabled");
                } else {
                    _.set(aftra, this.field_payTransactions, []);
                    aftra.hasPaytransactionChanged = true;
                    //$("[name='btnpayrolltransactions-" + aftra.id + "']").removeAttr("disabled");
                }
                // $("[name='jobCode-" + aftra.id + "']").addClass("required-outline");
            } else {
                _.set(aftra, this.field_contractCode, null);
                _.set(aftra, this.field_payTransactions, []);

                _.set(aftra, "rateCode", this.DEFAULT_RATE_CODE);
                //$("[name='payrolladdtransactions-" + aftra.id + "']").removeClass("hidden");
                //$("[name='btnpayrolltransactions-" + aftra.id + "']").attr("disabled", "disabled");
                aftra.hasPaytransactionChanged = true;
                //$("[name='jobCode-" + aftra.id + "']").removeClass("required-outline");
            }
            this.setPayTransactions(aftra);

            //setDropdowns($("[name='contractCode-" + aftra.id + "']"), allContractCodes, "name", "id", true, null, true, "-Select-", null);
            //setDropDownValue(aftra, field_jobCode, allJobCodes[aftrajobCodeIndex].code, jobCodeSelector);
            this.defaultJobCodeDetails(
                aftra,
                this.allJobCodes[aftrajobCodeIndex]
            );
            //if (!_.isEmpty(aftra.jobCodeDetail)) {
            //  setDropdowns($("[name='jobCodeDetail-" + aftra.id + "']"), aftra.jobCodeDetail, "rateCode", "rateCode", true, "00", true, "00", null);
            //}
        }
    }

    /*Method has no associated workflow relations*/
    onBulkDropDownUpdate(listItems, prop, value) {
        _.forEach(listItems, (item) => {
            item[prop] = value;

            //let index = this.getListItemIndex(item.id);
            //this.modifiedListItems[index][prop] = value;
            //this.updateGridRow(item);
            //setDropDownValue(item, prop, value, selector);
        });
    }

    bulkUpdateCostCenterChange(listItems, prop) {
        _.forEach(listItems, (item) => {
            //get row
            if (prop.wbseOption === "wbseOption") {
                this.costCenterTypeChange(item, "isWbse");

                //$("#wbse-" + item.id).find("input").val(prop.wbseCode.code);
                //$("#wbse-" + item.id).find("input").attr("title", prop.wbseCode.description);
                //$("#costCenterType-wbse-" + item.id).prop("checked", true);

                item.wbse = prop.wbseCode.code;
                item.wbseDescription = prop.wbseCode.description;
                this.setCompanyCode(
                    prop.wbseCode.coCode,
                    this.getListItemIndex(item.id)
                );
            } else {
                this.costCenterTypeChange(item, "isCostCenter");
                item.wbse = null;
                item.costCenter = prop.wbseCode.code;
                //$("#costCenter-" + item.id).find("input").val(prop.wbseCode.code);
                //$("#costCenterType-costCenter-" + item.id).prop("checked", true);
            }
        });
    }

    bulkUpdatePayrollCostCenterChange(listItems, prop) {
        _.forEach(listItems, (item) => {
            this.costCenterTypeChange(item, "isCostCenter");
            item.wbse = null;
            item.costCenter = prop.payrollCostCenter;
        });
    }

    /*
     * changes the user selection for wbse / cost center
     */
    onCostCenterChange($index, field) {
        const listItem = this.modifiedListItems[$index];
        this.costCenterTypeChange(listItem, field);
    }

    costCenterTypeChange(listItem, field) {
        listItem.isWbse = false;
        listItem.isCostCenter = false;
        const aftraItem = this.getChildListItem(listItem.id);

        if (field === "isWbse") {
            listItem.isWbse = true;
            //$("#wbse-" + listItem.id).show();
            //$("#wbse-" + listItem.id).find("input").val("");
            //$("#costCenter-" + listItem.id).hide();
            listItem.costCenter = null;
            //SCOR-16067
            if (!_.isEmpty(aftraItem)) {
                //$("#wbse-" + aftraItem.id).show();
                //$("#wbse-" + aftraItem.id).find("input").val("");
                //$("#costCenter-" + aftraItem.id).hide();
                aftraItem.isWbse = true;
                aftraItem.costCenter = null;
            }
        } else {
            listItem.isCostCenter = true;
            //$("#wbse-" + listItem.id).hide();
            //$("#costCenter-" + listItem.id).show();
            //$("#costCenter-" + listItem.id).find("input").val("");

            //we need to update the value to null
            listItem.wbse = null;
            //SCOR-16067
            listItem.wbseDescription = null;
            if (aftraItem) {
                //$("#costCenter-" + aftraItem.id).show();
                //$("#costCenter-" + aftraItem.id).find("input").val("");
                //$("#wbse-" + aftraItem.id).hide();
                aftraItem.isCostCenter = true;
                aftraItem.wbse = null;
                aftraItem.wbseDescription = null;
            }
        }
    }

    onBulkUpdateStateContactWorked(items, value) {
        let isWorkStateUpdate = true;
        _.forEach(items, (item) => {
            if (!item.businessValidation.isWorkStateValidation) {
                isWorkStateUpdate = false;
            }
        });

        if (isWorkStateUpdate) {
            _.forEach(items, (item) => {
                if (item.businessValidation.isWorkStateValidation) {
                    item.stateContactWorked = value;
                    //item.stateContactWorked = { "id": value, "name": value, "description": value };
                    //setDropDownValue(item, field_stateContactWorked, value, workStateSelector);
                }
            });
        } else {
            this.log.showError("Work State cannot be updated for this Employee Type");
        }
    }

    onBulkUpdateUnionCodeChanged(listItems, prop, value) {
        _.forEach(listItems, (item) => {
            //var lookupObj = { id: value, name: "", description: "" };
            //item[prop] = value;
            //setDropDownValue(item, prop, value, selector);
            const index = this.getListItemIndex(item.id);
            //var $row = $(rowSelector + item.id, $grid);
            //var $el = $row.find(selector);
            this.unionCodeChangeLogic(index, prop, value);
        });
    }

    onUnionCodeChanged($index, prop) {
        this.unionCodeChangeLogic(
            $index,
            prop,
            this.modifiedListItems[$index][prop]
        );
    }

    /**
     * this is centralized logic for union code.
     * Same method will be called from group update as well as from single dropdown value change
     * */
    unionCodeChangeLogic(index, prop, value) {
        const item = this.modifiedListItems[index];
        const childItem = this.getChildListItem(item.id);

        // If selected Value === "UNE"
        if (value?.description === this.AftraUnionCodes[0]) {
            if (item.isAftraPayment === "Y") {
                childItem.unionCode = this.AftraUnionCodes[1];

                //$("[name='unionCode-" + childItem.id + "']").val(AftraUnionCodes[1]);
                this.unionJobCodeChnages(
                    childItem,
                    "RTS00",
                    this.AftraUnionCodes[1],
                    {
                        id: this.AftraUnionCodes[1],
                        name: "",
                        description: this.AftraUnionCodes[1],
                    }
                );
                this.unionJobCodeChnages(item, "UNE00", this.AftraUnionCodes[0], {
                    id: this.AftraUnionCodes[0],
                    name: "",
                    description: this.AftraUnionCodes[0],
                });
            } 
            else if(item.isAftraPayment === "N" && _.isNull(item.parentTimecard)) {
                this.unionJobCodeChnages(item, "UNE00", this.AftraUnionCodes[0], {
                    id: this.AftraUnionCodes[0],
                    name: "",
                    description: this.AftraUnionCodes[0],
                });                
            }

            this.setChanged(item);
        } // If selected Value === "RTS"
        else if (value?.description === this.AftraUnionCodes[1]) {
            if (item.isAftraPayment === "Y") {
                childItem.unionCode = this.AftraUnionCodes[0];
                //$("[name='unionCode-" + childItem.id + "']").val(AftraUnionCodes[0]);
                this.unionJobCodeChnages(
                    childItem,
                    "UNE00",
                    this.AftraUnionCodes[0],
                    {
                        id: this.AftraUnionCodes[0],
                        name: "",
                        description: this.AftraUnionCodes[0],
                    }
                );
                this.unionJobCodeChnages(item, "RTS00", this.AftraUnionCodes[1], {
                    id: this.AftraUnionCodes[1],
                    name: "",
                    description: this.AftraUnionCodes[1],
                });
                this.setChanged(item);
            } else if(item.isAftraPayment === "N" && _.isNull(item.parentTimecard)) {
                this.unionJobCodeChnages(item, "RTS00", this.AftraUnionCodes[1], {
                    id: this.AftraUnionCodes[1],
                    name: "",
                    description: this.AftraUnionCodes[1],
                });
                this.setChanged(item);
            }
            
        } // If selected Value other than RTS or UNE 
        else {
            //TODO: BELOW CALL WILL HAVE ISSUE. REASON IN FUNCTION
            this.updateModelValue_1(index, prop, value); //SCOR-22365
            this.unionJobCodeChnages(
                item,
                "UNE00",
                this.AftraUnionCodes[0],
                value
            );
            if (item.isAftraPayment === "Y") {
                this.unionJobCodeChnages(
                    childItem,
                    "UNE00",
                    this.AftraUnionCodes[0],
                    value
                );
            }
        }
    }

    unionJobCodeChnages(item, jobcode, value, lookupObj) {
        _.set(item, this.field_unioncode, lookupObj);
        _.set(item, this.field_jobCode, jobcode);
        _.set(item, this.field_ratecode, this.DEFAULT_RATE_CODE);

        const jobCodeIndex = _.findIndex(this.allJobCodes, { code: value });
        //setDropDownValue(item, field_jobCode, value, jobCodeSelector);
        this.defaultJobCodeDetails(item, this.allJobCodes[jobCodeIndex]);
    }

    updateModelValue(index, prop) {
        //TODO: THIS IS INCORRECT. Sometimes, where id is actual id, we are still considering description. It is wrong. We need to find a way while
        //debugging bulk update method unionCodeChangeLogic()
        //let value = this.modifiedListItems[index][prop];

        //if (!value || value === "null") {
        //  value = null;
        //}
        //var lookupObj = { id: value, name: "", description: value };
        //_.set(this.modifiedListItems[index], prop, lookupObj);
        this.setChanged(this.modifiedListItems[index]);
        this.updateAftraChildRecord(this.modifiedListItems[index], prop);
    }

    updateModelValue_1(index, prop, value) {
        const item = this.modifiedListItems[index];
        item[prop] = value;
        this.setChanged(item);
        this.updateAftraChildRecord(this.modifiedListItems[index], prop);
    }

    /**
     * This method initiates the aftra child update.
     */
    updateAftraChildRecord(item, prop) {
        const aftraChild = this.getChildListItem(item.id);
        if (aftraChild) {
            aftraChild[prop] = item[prop];
            this.updateGridRow(aftraChild);
        }
    }

    /**
     * bulk update method for Wage Type
     */
    onBulkUpdateWageType(listItems, prop, value) {
        _.forEach(listItems, (item) => {
            //var $row = $(rowSelector + item.id, $grid);
            //var $el = $row.find(selector);
            //$el.val(value);
            const index = this.getListItemIndex(item.id);
            this.updateListItem(index, prop, value);
        });
    }

    /**
     * bulk update method for Wage schedule
     */
    onBulkUpdatewageschedule(listItems, prop, value) {
        _.forEach(listItems, (item) => {
            //var $row = $(rowSelector + item.id, $grid);
            //var $el = $row.find(selector);
            //$el.val(value);
            const index = this.getListItemIndex(item.id);
            this.updateListItem(index, prop, value);
        });
    }

    /*
     * update text value.
     * send the impacted list item
     */
    updateListItem(index, prop, value) {
        const item = this.modifiedListItems[index];

        let cleanedValue = null;
        if (_.trim(item[prop]) !== "null") {
            cleanedValue = _.trim(value);
        }
        item[prop] = cleanedValue;
        this.setChanged(item);
        this.updateAftraChildRecord(item, prop);
    }

    checkPayrollDefaults(item, Type) {
        if (
            Type === "EmployeeType" &&
            item &&
            item.employeeType &&
            item.currentProcessingDepartment.description === "PAYROLL"
        ) {
            const employeeTypeItem = _.find(this.employeeTypes, {
                id: item.employeeType.id,
            });
            let defaultListItem;
            if (employeeTypeItem) {
                defaultListItem = _.find(this.payrollDefaultsList, {
                    employeeType: employeeTypeItem.description,
                });
            }

            if (defaultListItem) {
                const id = item.id;
                const contractCode = _.find(this.allContractCodes, {
                    name: defaultListItem.tkContractCode,
                });
                const index = this.getListItemIndex(id);

                item = this.setContractCode(item, contractCode, null);

                this.modifiedListItems[index] = item;

                //TODO: NOT NEEDED:CONFIRM AND DELETE
                //Set Contract Code
                //setDropDownValue(item, field_contractCode, item.contractCode.id, contractCodeSelector);

                //Set Transaction types on change
                if (item.contractCode && item.contractCode.name) {
                    item.contractCode = _.find(this.allContractCodes, {
                        name: item.contractCode.name,
                    });
                    item.transactionTypes = _.orderBy(
                        item.contractCode.transactionTypes,
                        ["description"],
                        ["asc"]
                    );
                } else {
                    item.indicators = this.allContractCodes[0].indicators;
                    item.ruleVariances = this.allContractCodes[0].ruleVariances;
                    item.transactionTypes = _.orderBy(
                        this.allContractCodes[0].transactionTypes,
                        ["description"],
                        ["asc"]
                    );
                }

                //Set JobCode
                //var jobCode = _.find(this.allJobCodes, { code: item.contractCode && item.contractCode.name && item.contractCode && item.contractCode.name == "EXEMPT" ? item.unionCode && item.unionCode.id !== "RTS" ? defaultListItem.jobCode : "RTS" : defaultListItem.jobCode});

                var defaultJobCode = null;
                if (item.contractCode && item.contractCode.name == "EXEMPT") {
                    if (item.unionCode && item.unionCode.id !== "RTS") {
                        defaultJobCode = "UEX";
                    } else {
                        defaultJobCode = "RTS";
                    }
                } else if (item.unionCode && item.unionCode.id == "RTS") {
                    defaultJobCode = "RTS";
                } else if (item.unionCode && item.unionCode.id == "UNE") {
                    defaultJobCode = "UNE";
                } else if (item.employeeType && item.employeeType.id == "DGADIR") {
                    defaultJobCode = "DT1";
                } else {
                    defaultJobCode = "UNE";
                }

                var jobCode = _.find(this.allJobCodes, {
                    code: defaultJobCode,
                });

                if (jobCode && jobCode.details) {
                    item.jobCodeDetails = jobCode.details;
                    item.jobCodeDetail = _.find(item.jobCodeDetails, {
                        employeeType: jobCode.code,
                    });
                    item.jobCode = item.jobCodeDetail.code;
                    item.jobcode = item.jobCodeDetail.code;
                    item.selectedJobCode = jobCode.code;

                    //TODO: NOT NEEDED:CONFIRM AND DELETE
                    //setDropDownValue(item, field_jobCode, jobCode.code, jobCodeSelector);
                } else {
                    item.selectedJobCode = jobCode ? jobCode.code : "UNE";
                }

                //TODO: NOT NEEDED:CONFIRM AND DELETE
                //  var $elContractCode = $("select[name='contractCode-" + id + "']");

                //  if (item.contractCode !== null && defaultListItem) {
                //    $("[name='btnpayrolltransactions-" + item.id + "']").removeAttr("disabled");
                //}
            }
            if (Type === "ContractCode") {
                defaultListItem = _.find(this.payrollDefaultsList, {
                    tkContractCode: item.contractCode.name,
                });
                if (item.contractCode !== null && defaultListItem) {
                    //TODO: NOT NEEDED:CONFIRM AND DELETE
                    //$("[name='btnpayrolltransactions-" + item.id + "']").removeAttr("disabled");

                    //Set JobCode
                    //jobCode = _.find(this.allJobCodes, { code: item.contractCode && item.contractCode.name && item.contractCode && item.contractCode.name == "EXEMPT" ? item.unionCode && item.unionCode.id !== "RTS" ? defaultListItem.jobCode : "RTS" : defaultListItem.jobCode });

                    var defaultJobCode = null;
                    if (
                        item.contractCode &&
                        item.contractCode.name == "EXEMPT"
                    ) {
                        if (item.unionCode && item.unionCode.id !== "RTS") {
                            defaultJobCode = "UEX";
                        } else {
                            defaultJobCode = "RTS";
                        }
                    } else if (item.unionCode && item.unionCode.id == "RTS") {
                        defaultJobCode = "RTS";
                    } else if (item.unionCode && item.unionCode.id == "UNE") {
                        defaultJobCode = "UNE";
                    } else if (item.employeeType && item.employeeType.id == "DGADIR") {
                        defaultJobCode = "DT1";
                    } else {
                        defaultJobCode = "UNE";
                    }

                    var jobCode = _.find(this.allJobCodes, {
                        code: defaultJobCode,
                    });

                    if (jobCode && jobCode.details) {
                        item.jobCodeDetails = jobCode.details;
                        item.jobCodeDetail = _.find(item.jobCodeDetails, {
                            employeeType: jobCode.code,
                        });
                        item.jobCode = item.jobCodeDetail.code;
                        item.jobcode = item.jobCodeDetail.code;
                        item.selectedJobCode = jobCode.code;

                        //TODO: NOT NEEDED:CONFIRM AND DELETE
                        //setDropDownValue(item, field_jobCode, jobCode.code, jobCodeSelector);
                    } else {
                        item.selectedJobCode = jobCode ? jobCode.code : "UEX";
                    }
                }
            }
        }
    }

    onActivityDateChange(index, event) {
        const item = this.modifiedListItems[index];
        item.businessValidation.isFutureActivity =
            moment().endOf("week") < moment(item.activityDate);
        item.activityDate =
            item.activityDate == undefined
                ? null
                : moment(item.activityDate).format("MM/DD/YYYY");
        this.setChanged(item);
        this.updateAftraChildRecord(item, "activityDate");
        this.onBlurDatavalidation(index);
    }

    onHoursWorkedChange(index, changedValue) {
        this.updateListItem(index, "hoursWorked", changedValue);
    }

    onEvenShowNameChange(index, changedValue) {
        this.updateListItem(index, "eventShowName", changedValue);
    }

    onCostCenterInputChange(index, changedValue) {
        this.updateListItem(index, "costCenter", changedValue);
    }

    onWbseInputChange(index, changedValue) {
        this.updateListItem(index, "wbse", changedValue);
    }

    onWageTypeChange(index, changedValue) {
        this.updateListItem(index, "wageType", changedValue);
    }

    onWagescheduleChange(index, changedValue) {
        this.updateListItem(index, "wageschedule", changedValue);
    }

    onGlAccountSelected($event, index) {
        this.updateListItem(index, "glAccount", $event.glAccount);
    }

    onTimecardRateChange(index) {
        const item = this.modifiedListItems[index];

        if (_.isNaN(_.parseInt(item.rate))) {
            item.rate = this.TIMECARDRATE_DEFAULT;
        }
        this.setChanged(item);
    }

    onCustomRateChange(index) {
      const listItem = this.modifiedListItems[index];
        this.aftraRelatedFieldChangeImpact(listItem);
        this.payrollCustomRateFieldChanges(listItem);
        this.updateAftraChildRecord(listItem, this.field_customRate);
        this.validateRow(index);
        this.setChanged(listItem);
        const rawRate = typeof listItem.customRate === 'string'
            ? parseFloat(listItem.customRate.replace(/,/g, ''))
            : listItem.customRate;
        listItem.isRateDayHigh = !_.isNil(listItem.customRate) && rawRate > 50000;
  }

  customFormat(index) {
    const listItem = this.modifiedListItems[index];
    if (listItem.customRate) {
      listItem.customRate = this.formatNumber(listItem.customRate);
    }
  }

  formatNumber(value: number | string): string {
      // Handle empty, null, or undefined input
      if (value === null || value === undefined || value === '') {
        return '';
      }

      // Convert the input to a number
      let numericValue: number;
      if (typeof value === 'string') {
        numericValue = parseFloat(value.replace(/,/g, '')); // Remove commas if present
      } else {
        numericValue = value;
      }

      // Validate if the input is a valid number
    if (isNaN(numericValue)) {
        throw new Error('Invalid input: value is not a valid number.');
      }

      // Format the number with commas and two decimal places
      return numericValue.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }



    onAftraPercentageChanged($index, val) {
        const item = this.modifiedListItems[$index];
        if (
            val &&
            (parseInt(item.aftraPercentage, 10) === 0 ||
                parseInt(item.aftraPercentage, 10) > 100)
        ) {
            item.aftraPercentage = null; //SCOR-22366
            this.log.showError("Aftra percentage must be between 1 to 100");
            //setAftraPecentage(item.id, item.aftraPercentage);
            return;
        } else {
            //updateListItem($(this));
            this.aftraRelatedFieldChangeImpact(item);
            this.payrollCustomRateFieldChanges(item);
        }
    }
    onAftraPercentageTyped(index, val) {
        //MAY NOT NEEDED. Angular will use HTML Conditions to hide show
        //let item = this.getListItemIndex(index);
        //let aftraItem = this.getChildListItem(item.id);
    }
    aftraRelatedFieldChangeImpact(item) {
        //var $eleSplit = getAftraSplitButton(item.id);
        const aftraPercentage: any = item.aftraPercentage
            ? this.getFloat(item.aftraPercentage)
            : 0;
        const customRate: any = this.getFloat(item.customRate);

        const childAftraItem = this.getChildListItem(item.id);
        if (aftraPercentage && aftraPercentage > 0 && aftraPercentage < 100) {
            //parent row being edited
            //if (item.isAftraPayment === "N") {
            //  $eleSplit.removeClass("hidden");
            //}
            item.hasAftraChanged = true;
            item.aftraAmount = this.getFloat(
                (aftraPercentage * customRate) / 100
          );

          if (!_.isNil(item.aftraAmount)) {
            item.aftraAmount = this.formatNumber(item.aftraAmount);
          }

            //this.setAftraAmount(item.id, item.aftraAmount);

            //if aftra child row exists, we need to update the impact
            if (childAftraItem && item.aftraPercentage > 0) {
                childAftraItem.hasAftraChanged = true;
                childAftraItem.aftraPercentage = 100 - aftraPercentage;
                childAftraItem.aftraAmount = this.getFloat(
                    customRate - item.aftraAmount
              );

              if (!_.isNil(childAftraItem.aftraAmount)) {
                childAftraItem.aftraAmount = this.formatNumber(childAftraItem.aftraAmount);
              }
                //$("input[name='" + "aftraPercentage-" + childAftraItem.id + "']").val(childAftraItem.aftraPercentage);
                //setAftraAmount(childAftraItem.id, childAftraItem.aftraAmount);
            }
        }
        //SCOR-15774
        else if (aftraPercentage && parseInt(aftraPercentage, 10) === 100) {
            //var $eleMerge = getAftraMergeButton(item.id);
            //if ($eleSplit) {
            //  $eleSplit.addClass("hidden");
            //}
            //if ($eleMerge) {
            //  $eleMerge.addClass("hidden");
            //}
            if (item.isAftraPayment === "Y") {
                this.onAftraMerge(item);
            }
            item.aftraAmount = this.getFloat(
                (aftraPercentage * customRate) / 100
          );
          if (!_.isNil(item.aftraAmount)) {
            item.aftraAmount = this.formatNumber(item.aftraAmount);
          }

            //setAftraAmount(item.id, item.aftraAmount);
        } else {
            if (childAftraItem) {
                //var $childRow = $(rowSelector + childAftraItem.id);

                if (
                    parseInt(childAftraItem.aftraPercentage, 10) === 0 ||
                    !childAftraItem.aftraPercentage
                ) {
                    childAftraItem.aftraAmount = null;
                    //setAftraAmount(childAftraItem.id, childAftraItem.aftraAmount);
                } else {
                    childAftraItem.aftraAmount = this.getFloat(
                        (aftraPercentage * customRate) / 100
                  );

                    if (!_.isNil(childAftraItem.aftraAmount)) {
                    childAftraItem.aftraAmount = this.formatNumber(childAftraItem.aftraAmount);
                    }

                    // setAftraAmount(childAftraItem.id, childAftraItem.aftraAmount);
                }
                childAftraItem.hasAftraChanged = true;

                //parent aftra amount change
                if (parseInt(aftraPercentage, 10) === 0 || !aftraPercentage) {
                    item.aftraAmount = null;
                    childAftraItem.aftraAmount = null;
                    childAftraItem.aftraPercentage = null;
                    //setAftraAmount(item.id, item.aftraAmount);
                } else {
                    item.aftraAmount = this.getFloat(
                        (aftraPercentage * customRate) / 100
                    );

                    if (!_.isNil(item.aftraAmount)) {
                      item.aftraAmount = this.formatNumber(item.aftraAmount);
                    }
                    //setAftraAmount(item.id, item.aftraAmount);
                }
            }
            //if ($eleSplit) {
            // $eleSplit.addClass("hidden");
            else if (parseInt(aftraPercentage, 10) === 0 || !aftraPercentage) {
                item.aftraAmount = null;
                //setAftraAmount(item.id, item.aftraAmount);
            } else {
                item.aftraAmount = this.getFloat(
                    (aftraPercentage * customRate) / 100
                );

              if (!_.isNil(item.aftraAmount)) {
                item.aftraAmount = this.formatNumber(item.aftraAmount);
                }

                // setAftraAmount(item.id, item.aftraAmount);
            }
        }
    }

    payrollCustomRateFieldChanges(item) {
        const list = [item];
        const childAftraItem = this.getChildListItem(item.id);
        if (childAftraItem) {
            list.push(childAftraItem);
        }
        //_.forEach(list, function (timecard) {
        //  //var payrollCustomRateKey = "payroll-customRate-" + timecard.id;
        //  //var $pCustomRate = $("input[name*='" + payrollCustomRateKey + "']");

        //  //var payrollAftraKey = "payroll-aftraAmount-" + timecard.id;
        //  //var pAftraAmount = $("input[name*='" + payrollAftraKey + "']");

        //  if (!timecard.aftraAmount || timecard.aftraAmount <= 0) {
        //    //$pCustomRate.removeClass("hidden");
        //    //$pCustomRate.val(timecard.customRate);
        //    //pAftraAmount.addClass("hidden");
        //  }
        //  else {
        //    //pAftraAmount.removeClass("hidden");
        //    //$pCustomRate.addClass("hidden");
        //    //pAftraAmount.val(timecard.aftraAmount);
        //  }
        //});
    }

    getFloat(number) {
        let result = "0.00";
        if (_.isNaN(_.parseInt(number, 10))) {
            result = "0.00";
        } else {
          if (typeof number === 'string') {
            result = parseFloat(number.replace(/,/g, '')).toFixed(2);
          }
          else {
            result = parseFloat(number).toFixed(2);
          }
          
        }
        return result;
    }

    onJobCodeChange($index, value) {
        const jobCode = _.find(this.allJobCodes, { code: value });
        if (jobCode) {
            this.changeJobCode($index, jobCode);
        } else {
            const item = this.modifiedListItems[$index];
            _.set(item, this.field_jobCode, null);
            _.set(item, "rateCode", null);
        }
    }

    onRateCodeChange(index, val) {
        let jobCode, jobCodeIndex, jobCodeDetail;
        if (
            this.modifiedListItems[index] &&
            this.modifiedListItems[index].jobCode.length === 5
        ) {
            jobCode = this.modifiedListItems[index].jobCode.substr(0, 3);
        } else {
            jobCode = this.modifiedListItems[index].jobCode;
        }

        jobCodeIndex = _.findIndex(this.allJobCodes, { code: jobCode });
        jobCodeDetail = _.find(this.allJobCodes[jobCodeIndex].details, {
            rateCode: val,
        });

        this.changeRateCode(index, jobCodeDetail);
    }
    onPayrollProviderChange(index, changedValue) {
        this.log.trace("payroll provider change");
        this.updateModelValue_1(index, "payrollProvider", changedValue);
        const item = this.modifiedListItems[index];
        this.tKFieldsAccessibility(item, changedValue);
    }
    ///SCOR-22257- To update the bulk updated value to grid Row..
    bulkUpdatePayrollProvider(listItems, prop, value) {
        _.forEach(listItems, (item) => {
            item[prop] = value;
            this.tKFieldsAccessibility(item, value);
        });
    }

    onContractCodeChange(listId, selectedContract) {
        const listItem = this.getListItemById(listId);
        const contractCode = selectedContract
            ? _.find(this.allContractCodes, { id: selectedContract.id })
            : null;

        _.set(listItem, this.field_payTransactions, []);
        listItem.hasPaytransactionChanged = true;

        //$("[name='payTransactions-" + listItem.id + "']").removeClass("hidden");
        //$("[name='edit-transactions-" + listItem.id + "']").addClass("hidden");

        if (listId > 0 && contractCode && listItem) {
            this.setContractCodesUpdatesOnChange(
                listItem,
                contractCode,
                false,
                null
            );
            //$("[name='payrolladdtransactions-" + listItem.id + "']").removeClass("hidden");
            //$("[name='btnpayrolltransactions-" + listItem.id + "']").removeAttr("disabled");
        } else {
            listItem.contractCode = null;
            // $("[name='btnpayrolltransactions-" + listItem.id + "']").attr("disabled", "disabled");
        }
        //set data for aftra
        const aftra = this.getChildListItem(listId);

        if (aftra) {
            _.set(aftra, this.field_payTransactions, []);
            aftra.hasPaytransactionChanged = true;
            this.setContractCodesUpdatesOnChange(
                aftra,
                contractCode,
                false,
                null
            );
            this.updateGridRow(aftra);
        }
        this.checkPayrollDefaults(listItem, "ContractCode");
        this.setChanged(listItem);
    }

    /*
     * Name of an event to log the effort. Text field
     */
    onSportChange($data, index, prop) {
        this.log.trace("sport change");
        this.updateModelValue_1(index, prop, $data);
    }

    /*
     * network change. No cascaded impact requested
     */
    onNetworkChange($data, index, prop) {
        this.log.trace("network change");
        this.updateModelValue_1(index, prop, $data);
    }

    /*
     * Field is not mandatory untill the payroll condition
     */
    onWorkStateChange($data, index, prop) {
        this.log.trace("work state change");
        this.updateModelValue_1(index, prop, $data);
    }

    /*
     * No impact expected on change
     */

    onCompanyCodeChange($data, index, prop) {
        this.log.trace("company code change");
        this.updateModelValue_1(index, prop, $data);
    }

    onPayrollNotesChanges($index) {
        //NO USE OF THIS IMPLEMENTATION. UNNCESSARY CARRIED
    }

    onInputChange(index, prop, deptKey) {
        const listItem = this.modifiedListItems[index];
        const aftrarecord = this.getChildListItem(listItem.id);
        if (index > -1) {
            const deptStatus = _.find(listItem.timecardStatus, function (o) {
                return o.tpmDepartment.description === deptKey;
            });
            deptStatus.comments = listItem[prop];
            deptStatus.hasChanged = true;
            this.setChanged(listItem);
            if (aftrarecord) {
                const aftradeptStatus = _.find(
                    aftrarecord.timecardStatus,
                    function (o) {
                        return o.tpmDepartment.description === deptKey;
                    }
                );
                aftradeptStatus.comments = listItem[prop];
                aftradeptStatus.hasChanged = true;
            }
        }
    }

    updateGridRow(listItem) {
        const modifiedItem = this.modifyDataset([listItem], this.departments);
        const index = _.findIndex(this.modifiedListItems, { id: listItem.id });
        if (index > -1) {
            this.modifiedListItems.splice(index, 1, modifiedItem[0]);
        } else {
            this.modifiedListItems.push(modifiedItem[0]);
        }
    }

    /**
     * Modify Dataset
     * @param listItems
     * @param departments
     * @returns
     */
    modifyDataset(listItems, departments) {
        this.log.trace("modifyDataset");
        const allowedBUAcccessIds = this.getBUAccessIdList(departments);
        let listItemIndex = 0,
            contractCode,
            jobCode;
        for (listItemIndex; listItemIndex < listItems.length; listItemIndex++) {
            let item = listItems[listItemIndex];

          if (item.customRate)
            item.customRate = this.formatNumber(item.customRate); 

            item.dept = this.getPreviousDeptInQueue(departments);
            const empConfig =
                item.employeeType && !_.isEmpty(item.employeeType.id)
                    ? this.getDefaultsForEmpType(item.employeeType.id)
                    : null;

            if (item.contractCode && item.contractCode.name) {
                item.contractCode = _.find(this.allContractCodes, {
                    name: item.contractCode.name,
                });
                // item.indicators = contractCode.indicators;
                // item.ruleVariances = contractCode.ruleVariances;
                item.transactionTypes = _.orderBy(
                    item.contractCode?.transactionTypes,
                    ["description"],
                    ["asc"]
                );
            } else {
                item.indicators = this.allContractCodes[0]?.indicators;
                item.ruleVariances = this.allContractCodes[0]?.ruleVariances;
                item.transactionTypes = _.orderBy(
                    this.allContractCodes[0]?.transactionTypes,
                    ["description"],
                    ["asc"]
                );
            }

            //SCOR-15764
            /* Business validations */
            item.businessValidation = _.cloneDeep(this.businessValidation);
            //getSpecialTaxationValidation(item);
            this.fieldRequired(item);

            //var currentDate = moment(new Date());
            //var days = moment.duration(currentDate.diff(item.activityDate)).asDays();
            //item.businessValidation.isFutureActivity = item.activityDate ? (days < 0) : false;
            item.businessValidation.isFutureActivity =
                moment().endOf("week") < moment(item.activityDate);

            //item.id = listItemIndex;
            //console.log("I AM THE DATE");
            //console.log(item.activityDate);
            if (item.activityDate) {
                item.activityDate = moment(item.activityDate).format(
                    "MM/DD/YYYY"
                ); //fix for SCOR - 22293
                //let x = new Date(item.activityDate);
                //item.activityDate = x;  //moment(item.activityDate).local().toDate();//moment(item.activityDate).format("MM/DD/YYYY");
            }

            item.jobCode = item.jobCode ? item.jobCode : "UNE00";
            if (item.jobCode.code === "UNE" && item.rateCode === "") {
                item.rateCode = "00";
            }
            item = this.transformJobCode(item);
            jobCode = _.find(this.allJobCodes, { code: item.selectedJobCode });
            item = this.defaultJobCodeDetails(item, jobCode);

            item.rate =
                item.payrollProvider && item.payrollProvider.id === "TK"
                    ? item.rate || 15
                    : null;

            item.rejectDept = "OPERATION";

            item.isWbse = !_.isEmpty(item.wbse);
            item.isCostCenter = !_.isEmpty(item.costCenter);

            if (!item.isWbse && !item.isCostCenter) {
                item.isWbse = true;
            }

            if (item.companyCode && typeof item.companyCode === "object") {
                const s = "";
                //checked for patching purpose. It seems the company code is expected as a string. But,
                //the UI model is object.
            } else if (item.companyCode) {
                //Note: Please do not change 'description' name as it is being used to map the value from it in 'FlexibleStringConverter' at Backend.
                const lookupObj = {
                    id: item.companyCode,
                    name: "",
                    description: item.companyCode,
                };
                item.companyCode = lookupObj;
            }

            if (_.isDate(item.timeIn) && _.isDate(item.timeOut)) {
                item.durationString = this.getDuration(
                    item.timeIn,
                    item.timeOut
                );
            }

            item = this.setSystemErrorMessages(item);
            item = this.transformTimesheetDisplayStatus(item);

            if (!item.payTransactions) {
                item.payTransactions = [];
            }

            //Every timecard will have different status w.r.t user loggeed in. This will provide info if user has submitted the record or not
            item.workflowStatus = this.getInQueueStatus(item);

            item.businessValidation.isParentTimecardPresent =
                item.parentTimecard ? true : false;
            item.businessValidation.isContactAvailable = !_.isEmpty(
                item.contact.firstName
            );
            item.businessValidation.isSelfQueueRecord =
                item.currentProcessingDepartment.id ===
                this.buAccess.departmentId
                    ? true
                    : false;
            item.businessValidation.isSelfDeptCreatedRecord =
                item.createdByDepartment.id === this.buAccess.departmentId
                    ? true
                    : false;
            item.businessValidation.isAftraRecord =
                item.isAftraPayment &&
                item.isAftraPayment === "Y" &&
                !!item.parentTimecard
                    ? true
                    : false;

            item.businessValidation.canClone =
                this.buAccess.department === "SUBMITTER" &&
                item.queueStatus !== "PREQUEUE";
            item.businessValidation.canReplace =
                item.businessValidation.isSelfDeptCreatedRecord &&
                item.currentProcessingDepartment.description === "SUBMITTER" &&
                !item.parentTimecard &&
                item.isPayrollSubmitted !== "Y";
            item.businessValidation.canUnlock =
                _.includes(
                    Object.keys(this.user.allFeatures),
                    "timecard.unlock"
                ) &&
                item.queueStatus === "POSTQUEUE" &&
                this.buAccess.department !== "PAYROLL" &&
                (!item.isPayrollSubmitted || item.isPayrollSubmitted !== "Y") &&
                !item.parentTimecard;
            if (item.payrollProvider && item.payrollProvider.id === "OTHER") {
                item.businessValidation.canUnlock = false;
            }
            item.businessValidation.canDelete =
                item.businessValidation.isSelfDeptCreatedRecord &&
                item.currentProcessingDepartment.description === "SUBMITTER" &&
                !item.parentTimecard &&
                item.isPayrollSubmitted !== "Y";

            // used for controlling individual select checkbox
            item.businessValidation.canSelect =
                ((item.businessValidation.isSelfDeptCreatedRecord &&
                    item.queueStatus === "PREQUEUE") ||
                    (item.queueStatus === "INQUEUE" && !item.parentTimecard)) &&
                item.queueStatus !== "POSTQUEUE" &&
                item.businessValidation.isContactAvailable &&
                !item.parentTimecard;
            if (
                !_.isEmpty(empConfig) &&
                this.buAccess.department === "PAYROLL"
            ) {
                item.businessValidation.canSelect =
                    item.businessValidation.canSelect &&
                    !empConfig.isReadOnlyTimecard &&
                    !this.isPayrollTimesheetSelectDisabled(item);
            }

            //submit operations when Operations is not yet submitted + (record is not self created & is in prequeue OR it is inQueue and is not aftra record)
            item.businessValidation.canSubmitOperation = this.canSubmitDept(
                item,
                "timecard.submitter.submit.retrieve"
            ); //this.buAccess.canSubmit && canSubmitDept(item, dept_Operation);
            item.businessValidation.canSubmitTalent = this.canSubmitDept(
                item,
                "timecard.approver.submit.retrieve"
            ); //this.buAccess.canSubmit && getDeptSubmissionStatus(item, dept_Operation) ? canSubmitDept(item, dept_Talent) : false;
            item.businessValidation.canSubmitFinance = this.canSubmitDept(
                item,
                "timecard.finance.submit.retrieve"
            ); //this.buAccess.canSubmit && (getDeptSubmissionStatus(item, dept_Operation) && getDeptSubmissionStatus(item, dept_Talent)) ? canSubmitDept(item, dept_Finance) : false;
            //FOR PAYROLL dept, when everyone has submitted, button will keep remain enabled as Payroll can submit anytime
            item.businessValidation.canSubmitPayroll =
                this.canSubmitDept(item, "timecard.payroll.submit.retrieve") &&
                item.paymentStatus !== "COMPLETED"
                    ? true
                    : false; //this.buAccess.canSubmit && (getDeptSubmissionStatus(item, dept_Talent) && getDeptSubmissionStatus(item, dept_Finance)) && item.paymentStatus !== "COMPLETED" ? true : false;

            //for save at TC row level
            item.businessValidation.canTcSaveOperation = this.canTcSaveDept(
                item,
                "timecard.submitter.save.retrieve"
            );
            item.businessValidation.canTcSaveTalent = this.canTcSaveDept(
                item,
                "timecard.approver.save.retrieve"
            );
            item.businessValidation.canTcSaveFinance = this.canTcSaveDept(
                item,
                "timecard.finance.save.retrieve"
            );
            item.businessValidation.canTcSavePayroll =
                this.canTcSaveDept(item, "timecard.payroll.save.retrieve") &&
                item.paymentStatus !== "COMPLETED"
                    ? true
                    : false;

            item.businessValidation.canApproverReject = this.canRejectDept(
                item,
                "timecard.approver.reject.retrieve"
            ); //this.buAccess.canSubmit && getDeptSubmissionStatus(item, dept_Operation) ? canSubmitDept(item, dept_Talent) : false;
            item.businessValidation.canFinanceReject = this.canRejectDept(
                item,
                "timecard.finance.reject.retrieve"
            ); //this.buAccess.canSubmit && (getDeptSubmissionStatus(item, dept_Operation) && getDeptSubmissionStatus(item, dept_Talent)) ? canSubmitDept(item, dept_Finance) : false;
            //FOR PAYROLL dept, when everyone has submitted, button will keep remain enabled as Payroll can submit anytime
            item.businessValidation.canPayrollReject =
                this.canRejectDept(item, "timecard.payroll.reject.retrieve") &&
                item.paymentStatus !== "COMPLETED"
                    ? true
                    : false; //this.buAccess.canSubmit && (getDeptSubmissionStatus(item, dept_Talent) && getDeptSubmissionStatus(item, dept_Finance)) && item.paymentStatus !== "COMPLETED" ? true : false;

            item.businessValidation.showRejectAlertIcon =
                item.rejectStatus &&
                item.rejectStatus[0].isRejected &&
                !item.rejectStatus[0].isSubmitted;
            item.businessValidation.showRejectAlert =
                item.rejectStatus &&
                this.buAccess.departmentId ===
                    item.rejectStatus[0].tpmDepartment.id;
            item.rejectComment =
                item.rejectStatus && item.rejectStatus[0].rejectcomments;
            item.rejectedDept =
                item.dept.length === 1 ? item.dept[0].department.id : null;

            item.businessValidation.isFinanceFieldEnabled =
                item.currentProcessingDepartment.id > 2;
            // Field enabled or disabled
            item.businessValidation.isFieldEnabled =
                (item.businessValidation.isSelfDeptCreatedRecord ||
                    item.businessValidation.isSelfQueueRecord) &&
                item.businessValidation.isContactAvailable &&
                item.queueStatus !== "POSTQUEUE";

            if (
                item.businessValidation.isFieldEnabled &&
                this.buAccess.department === this.dept_Payroll
            ) {
                //This is very specific requirement for payroll where payroll will have readonly access to the records submitted with payroll providers as OTHER
                const parentItemForUnionCode =
                    item.parentTimecard !== null
                        ? _.find(listItems, { id: item.parentTimecard })
                        : null;
                item.businessValidation.isFieldEnabled =
                    item.businessValidation.isFieldEnabled &&
                    this.checkPayrollRecordEditAccess(
                        item,
                        parentItemForUnionCode
                    );
            }

            //only applicable to Foreign and loan out corp
            item.businessValidation.isWorkStateValidation =
                this.checkIfWorkStateEnabled(item) &&
                item.businessValidation.isFieldEnabled;
            //SCOR-15775
            //if (item.businessValidation.isFinanceFieldEnabled && this.buAccess.department === dept_Payroll) {
            //SCOR-15848
            if (
                item.businessValidation.isFieldEnabled &&
                this.buAccess.department === this.dept_Payroll
            ) {
                //item.businessValidation.isWageTypeRequired = checkIfWageTypeEnabled(item) || item.payrollProvider.id === "SPB";
                item.businessValidation.isWageTypeRequired =
                    item.payrollProvider && item.payrollProvider.id === "SPB";
                //item.businessValidation.isWageScheduleRequired = item.payrollProvider.id === "SPB";//this check is not required in Talent; commenting per defect SCOR-22282
            }

            /**COLOR RELATED CODE*/
            item.processingDeptDisplayName = _.startCase(
                _.lowerCase(item.currentProcessingDepartment.description)
            );

            item.systemMessage = "This is an issue";

            /*SCOR-15357*/
            if (!_.isEmpty(item.payrollProvider)) {
                if (!_.isEmpty(item.paymentStatus)) {
                    const colorClasskey =
                        item.payrollProvider &&
                        item.payrollProvider.id === "SPB"
                            ? "spb-" + _.lowerCase(item.paymentStatus)
                            : _.lowerCase(item.paymentStatus);

                    item.paymentStatusColor =
                        this.colors.paymentStatus.get(colorClasskey);
                    //console.log("--> " + colorClasskey);
                }
                if (item.parentTimecard !== null) {
                    const parentItem = _.find(listItems, {
                        id: item.parentTimecard,
                    });
                    if (!_.isUndefined(parentItem)) {
                        if (!_.isEmpty(parentItem.paymentStatusColor)) {
                            item.paymentStatusColor =
                                parentItem.paymentStatusColor;
                        } else {
                            if (!_.isEmpty(parentItem.paymentStatus)) {
                                const parentItemcolorClasskey =
                                    parentItem.payrollProvider.id === "SPB"
                                        ? "spb-" +
                                          _.lowerCase(parentItem.paymentStatus)
                                        : _.lowerCase(parentItem.paymentStatus);

                                parentItem.paymentStatusColor =
                                    this.colors.paymentStatus.get(
                                        parentItemcolorClasskey
                                    );
                                item.paymentStatusColor =
                                    parentItem.paymentStatusColor;
                            }
                        }
                        item.paymentStatus = parentItem.paymentStatus;
                        item.errorCode = parentItem.errorCode;
                        item.errorDescription = parentItem.errorDescription;
                    }
                }
            }

            const aftraItem =
                item.isAftraPayment && item.isAftraPayment === "Y"
                    ? _.find(listItems, { parentTimecard: item.id })
              : null;

            // Formating the Aftra Amount
            if (!_.isNil(item.aftraAmount)) {
              item.aftraAmount = this.formatNumber(item.aftraAmount);
            }

          // Remove comma to check the conditions         
          let payRollCustomRate;
          if (typeof item.customRate === 'string') {
            payRollCustomRate = parseFloat(item.customRate.replace(/,/g, '')); // Remove commas if present
          } else {
            payRollCustomRate = item.customRate;
          }
          
            if (_.isNil(item.customRate)) {
              item.highlightRateCell = true;
            }else if (!_.isNil(item.customRate) && payRollCustomRate < 200) {
              item.highlightRateCell = true;
            } else {
              item.highlightRateCell = false;
            }

            item.isRateDayHigh = !_.isNil(item.customRate) && payRollCustomRate > 50000;
 
            this.transformTimesheetWorkFlowStatus(item, aftraItem);
            // item.timesheetWorkflowDeptColor = colors.timesheetWorkflowStatus.get(_.lowerCase(item.currentProcessingDepartment.description));

            /*SPB Payment Status*/
            item.SPBStatusValidation = _.cloneDeep(this.SPBStatusValidation);
            if (item.payrollProvider && item.payrollProvider.id === "SPB") {
                item.SPBStatusValidation.isSubmitted =
                    item.isPayrollSubmitted === "Y" &&
                    item.paymentStatus !== "Pending Authorization";
                item.SPBStatusValidation.isUnAuthorized =
                    item.paymentStatus === "Authorized";
                item.SPBStatusValidation.isRejected =
                    item.paymentStatus === "Paid";
            }

            if (item.contact) {
                item.contact.firstName = _.trim(item.contact.firstName);
                item.contact.lastName = _.trim(item.contact.lastName);
            }

            this.checkContactValidation(item);

            //custom properties for UI manipulations
            item.uniqueTrackById = this.getUniqueTrackByid(listItemIndex);
            item.isChanged = false;
            item.selected = false;
            item.disableAftraAfterSplit = false;

            if (item.eventShowName) {
                item.eventShowName = this.htmlDecode(item.eventShowName);
            }
        }
        return listItems;
    }

    emitAnEvent(source, target, data) {
        this._eventBusService.emit(new EmitEvent(source, target, data));
    }

    public trackItem(index: number, item: any) {
        return item.uniqueTrackById;
    }

    updateTrackingId(listIndex) {
        const stamp = this.getUniqueTrackByid(null);
        const item = this.modifiedListItems[listIndex];
        item.uniqueTrackById = stamp;
        this.modifiedListItems.splice(listIndex, 1, item);
    }

    getUniqueTrackByid(increment?) {
        let stamp = new Date().getTime();
        if (increment) stamp = stamp + increment;

        return stamp;
    }

    init() {
        this.log.trace("grid init");
        // var template = "<div class=\"grid-content-row grid-row\" id=\"row-100\" data-id=\"1000\"></div>";

        const initialJobCode = [];
        _.filter(this.jobCodes, function (o) {
          if (o.code === "UNE" || o.code === "UEX" || o.code === "RTS" || o.code === "DT1") {
                initialJobCode.push(o);
            }
        });
        this.allJobCodes = _.orderBy(initialJobCode, ["code"], ["asc"]);
        this.allContractCodes = _.orderBy(
            this.contractCodes,
            ["name"],
            ["asc"]
        );
        this.employeeTypes = _.orderBy(
            this.employeeTypes,
            ["description"],
            ["asc"]
        );

        //TODO:Check why needed
        //this.timesheetDate = this.query.timeCardDate;
        //this.timesheetType = type;

        this.departments.forEach((dept) => {
            if (dept.department.externalKey === "APPROVER") {
                this.hasTalentDepartment = true;
            }
        });
        this.departments.forEach((dept) => {
            if (dept.department.externalKey === "FINANCE") {
                this.hasFinanceDepartment = true;
            }
        });
        this.departments.forEach((dept) => {
            if (dept.department.externalKey === "PAYROLL") {
                this.hasPayrollDepartment = true;
            }
        });

        let isNewTimesheet = true;

        if (
            !_.isEmpty(this.timesheetListItems) &&
            this.timesheetListItems[0].id !== -999
        ) {
            isNewTimesheet = false;
            this.modifiedListItems = this.modifyDataset(
                this.timesheetListItems,
                this.departments
            );
        } else this.modifiedListItems = [];
        // var deptKeysWithAccess = this.getBUAccessKeyList(this.departments);
        this.getMandatoryFields();
        //TODO: check if necessary
        //if (BuAccess.department === 'SUBMITTER') {
        //  appendFixedHeaderToBody(gridHeaderHtml);
        //}

        //TODO
        //initDragDrop($grid);
        this.setPayrollDefaultsonLoad(this.timesheetListItems);

        //TODO check if necessary
        //                    setDirtyStatus($("form[name='timesheetCtr.timesheetForm']"), false);

        setTimeout(() => this.onDemandChangeDetection(), 500);
    }

    buildGrid(items) {
        this.timesheetListItems = items;
        this.init();
    }

    getContactClass(contact) {
        if (contact?.hasNabet === "Y" || contact?.isNabet === true) {
            return "payroll-nabet";
        } else if (
            contact?.hasCompanyCode === "Y" ||
            contact?.companyCode?.fieldValue === "K0WX"
        ) {
            return "payroll-companyCode";
        } else {
            return "";
        }
    }
 
    subscribeEventHandlers() {
        this.subs.sink = this._sharedDataService
            .getBuAccess()
            .subscribe((access) => (this.buAccess = access));

        this.subs.sink = this._eventBusService.on(
            "receiveBroadcastedMasterData",
            (data) => this.onMasterDataReceived(data)
        );

        this.subs.sink = this._eventBusService.on("buildGrid", (data) =>
            this.buildGrid(data)
        );

        this.subs.sink = this._eventBusService.on(
            "uiDeptVisibilityChanged",
            (data) => (this.uiDeptSettings = data)
        );

        this.subs.sink = this._eventBusService.on("onContactSelected", (data) =>
            this.onContactSelected(data)
        );

        this.subs.sink = this._eventBusService.on(
            "onUpdateOnContactSelect",
            (data) => this.onUpdateOnContactSelect(data)
        );

        this.subs.sink = this._eventBusService.on("bulkUpdate", (data) =>
            this.bulkUpdate(data)
        );

        this.subs.sink = this._eventBusService.on("bulkAction", (data) =>
            this.bulkAction(data)
        );

        this.subs.sink = this._eventBusService.on(
            "onSelectAllRecordsChange",
            (isSelectAllChecked) =>
                this.onSelectAllRecordsChange(isSelectAllChecked)
        );

        this.subs.sink = this._eventBusService.on(
            "onGlobalSubmit",
            (selectedTimecards) => this.onGlobalSubmit(selectedTimecards)
        );

        this.subs.sink = this._eventBusService.on(
            "onUpdatePayTransactions",
            (listItem) => this.onUpdatePayTransactions(listItem)
        );

        this.subs.sink = this._eventBusService.on(
            "onListItemChanged",
            (listItem) => this.setChanged(listItem)
        );

        this.subs.sink = this._eventBusService.on(
            "onTimecardRejectWithReason",
            (data) => this.onTimecardRejectWithReason(data)
        );
    }

    assignContactDnD(event: CdkDragDrop<string[]>, itemId) {
        const data = {
            id: itemId,
            contact: event.item.data,
        };
        this.onContactSelected(data);
    }

    ngDoCheck() {
        //this can help to triage change detection
        // console.log(34);
    }

    ngOnInit() {
        this.subscribeEventHandlers();
        this.viewContainerRef.createEmbeddedView(this.grid_row_template);
        setTimeout(
            () => this.viewContainerRef.element.nativeElement.remove(),
            100
        );
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    htmlDecode(input: string): string {
        const doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent;
    }

    triggerChange() {
        this.viewContainerRef.element.nativeElement.dispatchEvent(
            new Event("change.areYouSure")
        );
    }
}
